/**
 * Global utility functions & polyfills
 */
//Responsive Breakpoints
var isTablet, isMobile900, isMobile;

if ($(document).width() <= 1024) {
    if ($(document).width() <= 900 && $(document).width() > 720) {
        isMobile900 = true;
    }
    if ($(document).width() > 720) {
        isTablet = true;
    } else {
        isMobile = true;
    }
}

// LazyLoad activation options.
var lazyLoadOptions = {
  callback_set: function(element) {
    $(element).removeAttr('data-was-processed');
    $(element).removeClass("loading");
    $(element).removeClass("error");
  },
  callback_load: function(element) {
    $(element).removeAttr('data-src');
    $(element).removeAttr('data-was-processed');
    $(element).removeClass("loaded");
    $(element).removeClass("error");
  },
  callback_enter: function(element) {
    if ($(element).data('src') == '') {
      $(element).attr("src", "");
    }
  }
};

// LazyLoad activation variable.
var activateLazyLoading= new LazyLoad(lazyLoadOptions);

// LazyLoad update
$(document).click(function() {
  activateLazyLoading.update();
});

$( document ).ajaxComplete(function() {
  activateLazyLoading.update();
});

$(".owl-carousel").on('changed.owl.carousel', function() {
  activateLazyLoading.update();
});

/**
 * Display hidden carousels on window load
 */
$(window).on("load", function (e) {
	$(".owl-carousel").css("display","block");
});

/**
 * detect if the current platform is an Apple iOS mobile
 */
(function () {
    var iDevices = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ];

    if (!!navigator.platform) {
        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) {
                var body = document.querySelector('body');
                if (body.classList) {
                    body.classList.add('iOS-mobile');
                }
                else {
                    body.className += ' ' + 'iOS-mobile';
                }
            }
        }
    }
})();

/**********************************************************************************************************************/
// Responsive utilities end (Global vatiables, can be used anywhere)
/**********************************************************************************************************************/

/**
 * on load callback
 */
$(function () {

    /**
     *
     */
    $('.breadcrumb li:last-child a').on('click', function () {
        return false;
    });

    /* BRA-8399 */
    $(document).on('click', '.page-CSSRepairersWithMap .faq-banner a[data-analytic="banner"]', function (e) {
        e.preventDefault();
    });

    /**
     *
     * @type {*|jQuery|HTMLElement}
     */
    var toggleNav = $('.toggle-nav');

    /**
     *
     * @type {*|jQuery|HTMLElement}
     */
    var overlay = $('.overlay');

    /**
     *
     * @type {*|jQuery|HTMLElement}
     * @private
     */
    var _search = $('.search');

    $(window).on('resize', adaptMentions);
    bindCreateUpdateAddress();
    if (isMobile == true) {
        // menu mon compte
        $('.page-ifu-categories-list #ifu-search + .item > .filter-list').hide();
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var toggleAcc = $('.sidebar-filters .filters > .item:first-child:not(#rp-search, #faq-search, #accessoryProduct-search, #ifu-search)');
        toggleAcc.addClass('toggle');
        toggleAcc.siblings().hide();
        if (toggleAcc.siblings().is(':visible')) {
            $('.sidebar-filters .filters').addClass('open');
        }
        if (!$('body').hasClass('page-SubCategoryPage')) {
            $(document).on('touchstart', '.toggle', function () {
                toggleAcc.siblings().stop(true, true).slideToggle(300);
                $(this).parent().toggleClass('open');
            });
        }

        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var toggleAcc2 = $('.item:visible #accordionFiltersFaq > .accordion-group > .accordion-heading');
        toggleAcc2.addClass('toggle2');
        toggleAcc2.siblings().hide();
        $('.page-faq-categories-list .sidebar-filters .accordion-body, .page-ifu-categories-list .sidebar-filters .accordion-body, .page-AccessoryListPage .sidebar-filters .toggle2 + .accordion-body, .page-AccessoryFinishedProductDetailPage .sidebar-filters .accordion-body').removeClass('collapse');
        $(document).on('touchstart', '.toggle2', function (e) {
            e.preventDefault();
            $(this).next('.accordion-body').stop(true, true).slideToggle(300);
            $(this).parent().toggleClass('open');
        });

        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var toggleAcc3 = $('#accessoryProduct-search .filter-list .name, #ifu-search .filter-list .name');
        toggleAcc3.addClass('toggle3');
        toggleAcc3.siblings().hide();
        $(document).on('touchstart', '.toggle3', function (e) {
            e.preventDefault();
            $('.sidebar-filters .search').stop(true, true).slideToggle(300);
            $(this).parent().toggleClass('open');
        });
        $('.page-ifu-categories-list #ifu-search > div > div.name.toggle3').show();

        (function(){
            var targeter = $(".targeter");
            if (targeter.length > 0) {
                $('.collapse').removeClass('in');
                $('.accordion-toggle.active').removeClass('active').addClass('collapsed');
                $('[data-toggle="collapse"]').addClass('collapsed');
                targeter.on('click', function () {
                    $(this).next('.collapse').collapse('toggle');
                    $(this).toggleClass('targeter-active');
                });
            }
        })();
    }

    if ($('html').hasClass('lt-ie9')) {
        IE();
    }

    toggleNav.on('click touchstart', function (e) {
        openNav();
        e.preventDefault();
    });

    $('.main-nav .accordion-inner > ul > li:not(".direct-link") > a').on('click touchend', function (e) {
        e.preventDefault();
        if (!$(this).parent().hasClass('direct-link')) {
            if (!$(this).parents('.niv2').length) {
                toggleniv2($(this));
            }
        }
    });

    $('.mobile-back').on('touchstart', function (e) {
        e.preventDefault();
        if ($(this).hasClass('back')) {
            // On revient au niveau 1
            $('.niv2').removeClass('open');
            $('.niv1 .actif').removeClass('actif');
            $(this).removeClass('back')
        } else {
            // on ferme le menu
            openNav();
        }
    });

    if (isMobile == true) {
    	$('#trigger-search').on('click touchstart', function (e) {
    		e.preventDefault();
    		if (!$('.dropmenu').is(e.target) && $('.dropmenu').has(e.target).length === 0 && $('.open').has(e.target).length === 0) {
                $('.dropmenu').removeClass('open');
            }
    		if (!_search.hasClass('active')) {
                //$('#trigger-search').attr('type', 'submit');
                $('body').addClass('search-open');
                _search.addClass('active');
                $('.wrap-search input[type=TEXT]').focus();
                e.preventDefault();
            }
    		$(this).prev().slideDown();
    	});
    	$('.close-search').on('click touchstart', function (e) {
            e.preventDefault();
            $('body').removeClass('search-open');
            _search.removeClass('active');
            $('#search').blur();
            $(this).parent().slideUp();
        });
    }else {
    	$('#trigger-search').on('click touchstart', function (e) {
            e.preventDefault();
            if (!$('.dropmenu').is(e.target) && $('.dropmenu').has(e.target).length === 0 && $('.open').has(e.target).length === 0) {
                $('.dropmenu').removeClass('open');
            }
            if (!_search.hasClass('active')) {
                //$('#trigger-search').attr('type', 'submit');
                $('body').addClass('search-open');
                _search.addClass('active');
                $('.wrap-search input[type=TEXT]').focus();
                e.preventDefault();
            }
        });

    	$('.close-search').on('click touchstart', function (e) {
            $('body').removeClass('search-open');
            _search.removeClass('active');
            $('#search').blur();
            e.preventDefault();
        });
    }

    $(".head-entry .search form[name='search_form']").on('submit', function(event){
    	var minLength = parseInt(ACC.searchTextMinLength);
    	if($(".head-entry .search #search").val().length < minLength) {
    		event.preventDefault();
    	}
    });

    /**
     * JS suggestions popup
     */
    $("#search").on("change paste keyup", function() {
    	  if($(this).val().length>0){
    		  $('#NoResult').hide();
    	  }else{
    		  $('#NoResult').show();
    	  }
    });

    overlay.on('click', function (e) {
        $('.mobile-back').removeClass('back');
        openNav();
    });

    $('.dropdown-toggle').dropdown();

    if ($('.country').length) {
        $('.country > a').dropdown()
    }

    if ($('.page-homepage').length) {
        if (isMobile || isTablet) {
            /* Mobile Devices */
        } else {
            $('.master-slider .mobile-carousel').remove();
        }
    }

    /* Satisfaction FAQ */
    $('input[type=radio][name=notation]').on('change', function() {
        /**
         *
         * @type {*|jQuery}
         */
        var $notationForm = $(this).parents('.notation');
        $notationForm.find('input[type=submit]').prop("disabled", false);
        if ($('input[name=notation]:checked', $notationForm).val() == "false") {
            $notationForm.find('.amelioration').removeClass('hidden');
            $notationForm.find('#or').removeClass('hidden');
            $notationForm.find('#contactUs').removeClass('hidden');
        } else {
            $notationForm.find('.amelioration').addClass('hidden');
            $notationForm.find('#or').addClass('hidden');
            $notationForm.find('#contactUs').addClass('hidden');
        }
    });

    $(".notationForm").each(function () {
        $(this).on('submit', function (e) {
            e.preventDefault();
            /**
             *
             * @type {*|jQuery|HTMLElement}
             */
            var $this = $(this);

            /**
             *
             */
            var faqUtile = $this.find('.faqUtile:checked').val();

            if (faqUtile !== '') {
                $this.addClass('hidden');
                $this.parents('.notation').find('.thanks').removeClass('hidden');
                $.ajax({
                    url: $this.attr('action'),
                    type: $this.attr('method'),
                    data: $this.serialize(),
                });
            }
        });
    });

    // incription à la newsletter après la création de compte
    if ($("#ModalNewsLetter.my-space").length > 0) {
        $('#ModalNewsLetter.my-space').modal();
    }
    $(document).on('shown','.accordion-group' ,function (e) {
        $(e.target).prev('.accordion-heading').find('.accordion-toggle').addClass('active');
    });

    $(document).on('hidden','.accordion-group', function (e) {
        $(this).find('.accordion-toggle').not($(e.target)).removeClass('active');
    });

    /* SMOOTH SCROLL on anchor click */
    $('.logo a[href*=\\#]:not([href=\\#]), a.anchor[href*=\\#]:not([href=\\#])').on('click', function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            /**
             *
             * @type {*|jQuery|HTMLElement}
             */
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 115
                }, 900);
                return false;
              }
            } else {
              playGoCompare(jQuery(this));
            }

    });

    /* Placeholder fix */
    if (!Modernizr.input.placeholder) {
        $('[placeholder]').focus(function () {
            /**
             *
             * @type {*|jQuery|HTMLElement}
             */
            var input = $(this);
            if (input.val() == input.attr('placeholder')) {
                input.val('');
                input.removeClass('placeholder');
            }
        }).blur(function () {
            /**
             *
             * @type {*|jQuery|HTMLElement}
             */
            var input = $(this);
            if (input.val() == '' || input.val() == input.attr('placeholder')) {
                input.addClass('placeholder');
                input.val(input.attr('placeholder'));
            }
        }).blur();
        $('[placeholder]').parents('form').on('submit', function () {
            $(this).find('[placeholder]').each(function () {
                /**
                 *
                 * @type {*|jQuery|HTMLElement}
                 */
                var input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('');
                }
            })
        });
    }

    //init scrollable compare array in product detail page
    scrollableTable();

    if ($('.list-product').length) {
        refresh_compare();
        //add custom action on go compare
        initGoCompare();
    }

    $('.disabled').on('click', function (e) {
        e.preventDefault();
    });

    HighlightAutocomplete();

    /* Code temporaire seulement pour la démo de l'autocomplete */
    /* on vous prie de bien vouloir nettoyer le code
     * Merci d'avance.
     */

    /* iPad Hack to avoid two click instead of one*/
    $('.ui-autocomplete').on('touchstart', 'li.ui-menu-item', function () {
        /**
         *
         * @type {*|jQuery}
         */
        var $container = $(this).closest('.ui-autocomplete'),
            $item = $(this);
        //if we haven't closed the result box like we should have, simulate a click on the element they tapped on.
        /**
         *
         * @returns {boolean}
         */
        function fixitifitneedsit() {
            if ($container.is(':visible') && $item.hasClass('ui-state-focus')) {
                $item.trigger('click');
                return true; // it needed it
            }
            return false; // it didn't
        }

        setTimeout(function () {
            if (!fixitifitneedsit()) {
                setTimeout(fixitifitneedsit, 600);
            }
        }, 600);
    });

    /* fin demo autocomplete*/
    $('.nl-reset').on('click', function (event) {
        event.preventDefault();
        nlReset();
    });

    //close modal IE Managment
    $('.master-detail-product .modal').on('hidden', function () {
        /**
         *
         * @type {*|jQuery}
         */
        var iframe = $(this).children('div.modal-body').find('iframe');
        iframe.attr('src', '');
        $(this).removeData();
    });

    //close modal IE Managment
    $('#ModalCommerce').on('shown', function () {
        $(this).find('.modal-body').css({
            'max-height': '100%'
        });
    });

    // Moulisearch - SEE MORE handler
    handleMoulisearchLoad();

    // List product - SEE MORE handler
    $(document).on('click', '.list-recipe:not(".ugc") .show-more a', function (event) {
        $('.show-more').hide();
        /**
         *
         * @type {*|jQuery}
         */
        var url = $(this).attr("href");
        event.preventDefault();
        showLoader();
        $.ajax({
          url: url,
          type: 'GET',
          dataType: 'html',
          data: ''
        }).always(function (data) {
          $('.recipes-list').append(data);
          hideLoader();
        });
    });

    if ($('.list-news').length) {
        /**
         *
         * @type {number}
         */
        var nblitoshow = 5;
        $('.list-news ul li:nth-child(' + nblishown + ') ~ li').addClass('hidden');
        $(document).on('click', '.list-news .show-more a', function (event) {
            event.preventDefault();
            showLoader();
            /**
             *
             * @type {number|jQuery}
             */
            var nbLi = $('.list-news ul li').length,
                indexHidden = $('.list-news ul li').index($('.list-news ul li.hidden'));

            for (var i = indexHidden + 1; i < indexHidden + nblitoshow; i++) {
                $('.list-news ul li:nth-child(' + i + ')').removeClass('hidden');
                if (nbLi <= i) {
                    $('.list-news .show-more').hide();
                }
            }
            hideLoader();
        });
    }

    // Cookboard - SEE MORE handler
    $(document).on('click', '.cookboard .show-more a', function (event) {
        if (!$(this).parent().hasClass('open')) {
            /**
             *
             * @type {*|jQuery}
             */
            var url = $(this).attr("href");
            $('.show-more', $('.cookboard')).addClass('open');
            $('.show-more .more', $('.cookboard')).hide();
            $('.show-more .less', $('.cookboard')).show();
            if (!$(this).parent().hasClass('loaded')) {
              showLoader();
              $('.show-more', $('.cookboard')).addClass('loaded');
              $.ajax({
                url: url,
                type: 'GET',
                dataType: 'html',
                data: ''
              }).always(function (data) {
                $('.result-cookboards').append(data);
                hideLoader();
              });
            }
            $('.result-cookboards').show('300');
        } else {
            $('.result-cookboards').hide('300');
            $('.show-more', $('.cookboard')).removeClass('open');
            $('.show-more .more', $('.cookboard')).show();
            $('.show-more .less', $('.cookboard')).hide();
        }
        event.preventDefault();
    });

    $('.recipe-product .show-more a').on('click', function (e) {
        e.preventDefault();
        showLoader();
        $('.recipe-product-list .more').show();
        $('.recipe-product .show-more').hide();
        hideLoader();
    });

    $('a.trigger-content').on('click', function (e) {
        e.preventDefault();
        /**
         *
         * @type {*|jQuery}
         */
        var link = $(this).attr('href');
        if (!$(this).hasClass('open')) {
            $(link).stop(true, true).show('300');
            $(this).addClass('open')
        } else {
            $(link).stop(true, true).hide('300');
            $(this).removeClass('open')
        }
    });

    /**
     *
     */
    function adaptMentions() {
        /**
         *
         * @type {*|jQuery}
         */
        var tableComparWidth = $('.comparison .floatThead-container').width(),
            firstColWidth = $('.comparison .floatThead-container colgroup > col').first().width();
        $('.comparison .scrollableTable .mentions').width(tableComparWidth).css("padding-left", firstColWidth);
    }

    /**
     *
     */
    function openNav() {
        var simpleSlider;
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var mainNav = $('.main-nav'),
            toggleNav = $('.toggle-nav'),
            overlay = $('.overlay');
        $('.mobile-back').hide();
        if (mainNav.hasClass('show-nav')) {
            if (simpleSlider) {
                simpleSlider.startAuto();
            }
            mainNav.removeClass('show-nav');
            toggleNav.removeClass('active');
            $('.niv2').removeClass('open');
            $('.niv1 .actif').removeClass('actif');
            overlay.removeClass('open');
            $('.wrap-main-content').removeClass('open-nav');
        } else {
            if (simpleSlider) {
                simpleSlider.stopAuto();
            }
            toggleNav.addClass('active');
            mainNav.addClass('show-nav');
            mainNav.css("display","block");
            $('.niv2').css("display","block");
            overlay.addClass('open');
            $('.wrap-main-content').addClass('open-nav');
            $('.mobile-back').show();
        }
    }

    // Gestion de la section "Une humeur, des recettes"
    if ($('#nl-form').length) {
        /**
         *
         * @type {*|jQuery}
         */
        var tooltipLabel = $('.tooltipLabel').html();
        $('.nl-submit').addClass('inactive');
        if (!$('html').hasClass('lt-ie9')) {
            /**
             *
             * @type {*|NLForm}
             */
            var nlform = new NLForm(document.getElementById('nl-form'));

            setTimeout(function () {
                $('.nl-form div').attr({
                    "data-toggle": "tooltip",
                    "title": tooltipLabel
                });
                $('.nl-field').tooltip({
                    position: {
                        my: "center bottom",
                        at: "center top"
                    }
                }).tooltip("option", "show");
            }, '300');
        }
        $('#nl-form').on('submit', function (event) {
            event.preventDefault();
            /**
             *
             * @type {*|jQuery}
             */
            var op1 = $('#select-humeur').val(),
                op2 = $('#select-produit').val(),
                op3 = $('#select-pour').val();
            if (op1 != "" && op2 != "" && op3 != "") {
                showLoader();
                $('.form-humeur').addClass('submited');
                $('.nl-submit-wrap').hide();
                $('.more', '.humeur').show();
                $('.social-share', '.humeur').show();
                $.ajax({
                  //url: 'humeur-result.php?op1=' + op1 + '&op2=' + op2 + '&op3=' + op3,
                  url: ACC.recipe.moodsearchurl + '?op1=' + op1 + '&op2=' + op2 + '&op3=' + op3,
                  type: 'GET',
                  dataType: 'html',
                  data: ''
                }).always(function (data) {
                  $('.result-form').append(data);
                  $('html,body').animate({
                    scrollTop: $('.humeur').offset().top - 63
                  }, 500);
                  hideLoader();
                });
            }
        })
    }
    if ($('.addrBookContainer').length) {
        /**
         *
         * @type {number}
         */
        var HigherAddress = 0;
        $('.addrBookContainer .span4').each(function (index) {
            if ($(this).outerHeight() > HigherAddress) {
                HigherAddress = $(this).outerHeight();
            }
        });
        $('.addrBookContainer .span4').css('height', HigherAddress);
    }

    /*store locator detail*/
    $(document).on('click','.list-store li', function () {
        console.log("teeeeest");
        infowindow.close();
        $('.shopdetails').slideUp('fast');
        gotoPoint(jQuery(this).index(),jQuery(this).attr("id"));
    });


    $('.back-to-top a').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 1000);
    });

    // Au change du select de la liste des accessoires
    $("#faq-sort").on('change', function() {
        /**
         *
         * @type {*|jQuery}
         */
        var selectedValue = $(this).val();
        updateURLParameter("sort", selectedValue);
    });

    /**
     *
     * @param param
     * @param paramVal
     */
    function updateURLParameter(param, paramVal) {
        /**
         *
         */
        var url = window.location.href;

        /**
         *
         * @type {string}
         */
        var newAdditionalURL = "";

        /**
         *
         */
        var tempArray = url.split("?");

        /**
         *
         */
        var baseURL = tempArray[0];

        /**
         *
         */
        var additionalURL = tempArray[1];

        /**
         *
         * @type {string}
         */
        var temp = "";
        if (additionalURL) {
            tempArray = additionalURL.split("&");
            for (i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] != param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        }

        /**
         *
         * @type {string}
         */
        var rows_txt = temp + "" + param + "=" + paramVal;
        window.location = baseURL + "?" + newAdditionalURL + rows_txt;
    }

    $(".emptyCart").on('click', function (e) {
        e.preventDefault();
        $('.ConfModal').modal();
    });

    //gestion des menu du header
    $('.dropmenu .dropmenu-toggle, .country > a').on('click', function (e) {
        e.preventDefault();
        $('.search').removeClass('active');
        if ($(this).parent().hasClass('open')) {
            $(this).parent().toggleClass('open')
        } else {
            $('.dropmenu.open').removeClass('open');
            $(this).parent().toggleClass('open');
        }
    });

    // gestion du clique à l'exterieur des menus deroulants du header quand ils sont ouvert
    $('body').on('click', function (e) {
        if (!$('.dropmenu').is(e.target) && $('.dropmenu').has(e.target).length === 0 && $('.open').has(e.target).length === 0) {
            $('.dropmenu').removeClass('open');
        }
    });

    //prevent copy /paste
    $('.noctrlcv').on("cut copy paste", function (e) {
        e.preventDefault();
    });
    $('.noctrlcv').on('keydown',function (event) {
        if (event.ctrlKey == true && (event.which == '118' || event.which == '86')) {
            event.preventDefault();
        }
    });

    jQuery("#submitFormLoginAjax").on('click', function (event) {
        /**
         *
         */
        var baseURL = jQuery("#FormLogin").attr('action');

        /**
         *
         */
        var basesecureURL = jQuery("#FormLogin").attr('secure-action');
        jQuery("#messageErrorsLogin").html('');
        event.preventDefault();
        jQuery.ajax({
            type: "post",
            data: jQuery("#FormLogin").serialize(),
            url: baseURL + "/login/request/validate"
        }).done(function (data) {
            if (data.success == true) {
                jQuery("#FormLogin").attr('action',
                    basesecureURL + "/j_spring_security_check");
                jQuery("#FormLogin").trigger('submit');
            } else {
                jQuery("#messageErrorsLogin").html(data.message);
            }
        }).fail(function () {
            jQuery("#messageErrorsLogin").html(errorLogin);
        });
    });

    jQuery("#btn-mood").on('click', function (event) {
        /**
         *
         * @type {*|jQuery}
         */
        var op1 = $('#select-humeur').val(),
            op2 = $('#select-produit').val(),
            op3 = $('#select-pour').val();
        if (op1 == "" || op2 == "" || op3 == "") {
            /**
             *
             * @type {string}
             */
            var selectModal = '#ModalMoodSearch';
            $(selectModal).show();
            $(selectModal).modal();
        }
    });

    /* Retour a la lighe apres le point*/
    /**
     *
     * @type {*|jQuery}
     */
    var test = $('.quantity .msg span').text();

    /**
     *
     */
    var result = test.replace(/\./g, '.<br/>');

    $('.quantity .msg span').html(result);

    /* Pagination Handler*/
    if ($('.pagination').length) {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var $pagination = $('.pagination'),
            nbPage = $pagination.find('li').length, // Nombre de pages
            currentPage = $pagination.find('li.active').index(); // index de la page active
        $pagination.find('li').hide();
        for (var i = currentPage - 3; i < currentPage + 3; i++) {
            if (i >= 0 && i <= nbPage) {
                $pagination.find('li').eq(i).show();
            }
        }
        $pagination.find('li:last-child').show();
        $pagination.find('li:first-child').show();
    }

    $(document).on('click', '.CountrySeletorBC', function () {
        $(this).parent().find('.country-selector-bc').show();
    });

    $(document).on('mouseleave', '.country-selector-bc', function () {
        $('.country-selector-bc').hide();
    });

    /* Moulisearch Gestion de l'autoscroll */
    if ($('body').hasClass('page-MouliSearchPage')) {
        /**
         *
         */
        var filterMoulisearch = getUrlParameter('q');
        if (filterMoulisearch) {
            if (isMobile == true) {
                scrollToAnchor('#product-list', 49);
            } else {
                scrollToAnchor('.moulisearch .description', 70);
            }
        }
    }

    if (isMobile == true) {
        /**** Find idea page ****/
        /* change search submit text for icon */
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var recipeFinder = $('.page-RecipeHomePage .recipe-finder .container form .submit');
        recipeFinder.attr('value', '');
        /* put wrap-push at very end of new-recipe grid */
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var wrapPush = $('.page-RecipeHomePage .wrap-push');
        wrapPush.detach();
        wrapPush.appendTo($('.page-RecipeHomePage .recipe-layout'));

        /* put big cookboard before small ones */
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var bigCookboard = $('.page-RecipeHomePage .cookboard .big');
        bigCookboard.detach();
        bigCookboard.prependTo('.board');

        /* wrap filters in a div and create slideup/slidedown */
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var ourRecipeFilters = $('.list-recipe .span3 .accordion');
        $('.mobile-accordion-header').next('.accordion').hide();
        $('.mobile-accordion-header').on('touchstart', function () {
            $(this).next('.accordion').slideToggle();
            $(this).toggleClass('active');
        });
        /* put wrap-push at very end of list-recipe grid */
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var wrapPush = $('.list-recipe .span3 .wrap-push');
        //wrapPush.detach();
        wrapPush.appendTo($('.list-recipe .span9'));

        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var productListTrigger = $('.list-product .scroll-filters > .filters > .item:first-child');

        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var productListitem = $('.list-product .scroll-filters .filters .item:not(:first-child)');
        productListTrigger.addClass('toggle');
        productListitem.addClass('deploy');
        productListitem.hide();
        $(productListTrigger).on('touchstart', function () {
            productListitem.slideToggle();
            productListTrigger.toggleClass('active');
        });

        if ($('.zone-compare').length) {
            /**
             *
             * @type {*|jQuery}
             */
            var zoneCompare = $('.zone-compare').not('.zone-compare.bottom');
            zoneCompare.prependTo(".list-product .span9");
            $(window).scroll(function () {
                /**
                 *
                 * @type {{top, left}}
                 */
                var offset = zoneCompare.offset();

                /**
                 *
                 */
                var zoneComparePosY = offset.top;
                if ($(this).scrollTop() > zoneComparePosY - 60) {
                    $('.zone-compare').addClass("float");
                } else {
                    $('.zone-compare').removeClass("float");
                }
            });
        }

        $('.content-edito table').each(function () {
            $(this).wrap("<div class='table-container'></div>");
        });

        if ($('.recipe-layout').length) {
            $('.wrap-push').appendTo('.recipe-layout');
        }

        //deplacement des bannières pour le mobile.
        $('.page-search .row-fluid.bloc-head > .yCmsContentSlot .span12, .page-ProductComparatorPage .row-fluid.bloc-head > .span12').addClass('banner-mobile');
        $('.list-cat .span9 > .picture').prependTo('.list-cat > .row-fluid.bloc-light').addClass('banner-mobile');
        $('.store-on-line-intro > div > a > .border').prependTo('.page-StoreFinderOnLinePage .main-content > .row-fluid.bloc-light').addClass('banner-mobile');
        $('.page-CSSRepairersWithMap .span9 > .faq-banner .picture').prependTo('.page-CSSRepairersWithMap .main-content > .row-fluid.bloc-light').addClass('banner-mobile');
        $('.page-faqhomepage .span9 > .faq-banner .picture').prependTo('.page-faqhomepage .main-content > .row-fluid.bloc-light').addClass('banner-mobile');
    }

    if ($(document).width() >= 720 && document.documentElement.scrollTop > 0) {
        $('body').addClass("mini-header");
    }
    $(window).scroll(function () {
        if (isMobile !== true) {
            if ($(this).scrollTop() > 100) {
                if ($('body').is('.moulinex-portal')) {
                } else {
                    $('body').addClass("mini-header");
                }
            } else {
                $('body').removeClass("mini-header");
            }
        }
    });

    /* BRA-2657 */
    $(window).on("load", function (e) {
	    if ($('body').hasClass('page-ProductComparatorPage') && isMobile) {
	        /**
	         *
	         */
	        var headers;

	        /**
	         *
	         * @type {Array}
	         */
	        var headers_heights = [];

	        /**
	         *
	         */
	        var max_height;
	        headers = $('.page-ProductComparatorPage .product-comparison .scrollableTable .table thead tr th');
	        headers.each(function () {
	            headers_heights.push($(this).height());
	        });
	        max_height = Math.max.apply(Math, headers_heights);
	        headers.each(function () {
	            $(this).height(max_height);
	        });
	    }
    });
    /* BRA-2657 */

    /* BRA-1190 */
    if (isMobile) {
        /**
         *
         */
        var mobile_banner_section;

        /**
         *
         */
        var search_section;

        /**
         *
         */
        var content_section;

        /**
         *
         */
        var faq_container;
        // init
        mobile_banner_section = $('.page-faq-categories-list section.list-cat.list-products .banner-mobile');
        search_section = $('.page-faq-categories-list section.list-cat.list-products .span3');
        content_section = $('.page-faq-categories-list section.list-cat.list-products .span9');
        faq_container = $('.page-faq-categories-list section.list-cat.list-products');
        // detach all sections
        mobile_banner_section.detach();
        search_section.detach();
        content_section.detach();
        // reset all sections with correct order
        faq_container.append(mobile_banner_section);
        faq_container.append(search_section);
        faq_container.append(content_section);
        // fix mobile banner style
        mobile_banner_section.width('100%');
    }

    /* BRA-1190 */

});
//End

/**
 *
 * @param aid
 * @param delta
 */
function scrollToAnchor(aid, delta) {
    /**
     *
     * @type {*|jQuery|HTMLElement}
     */
    var aTag = $(aid);
    $('html,body').animate({scrollTop: aTag.offset().top - delta}, 'slow');
}

/**
 *
 * @param sParam
 * @returns {*}
 */
var getUrlParameter = function getUrlParameter(sParam) {
    /**
     *
     * @type {string}
     */
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

/**
 *
 * @param clickNiv1
 */
function toggleniv2(clickNiv1) {
    $('.niv2').removeClass('open');
    clickNiv1.parent().find('.niv2').addClass('open');
    $('.niv1 .actif').removeClass('actif');
    clickNiv1.addClass('actif');
    $('.mobile-back').addClass('back');
}


//Product Detail - Array product comparision
/**
 *
 */
function scrollableTable() {
    /**
     *
     * @type {Number}
     */
    var nbvisible = parseInt(jQuery('.scrollableTable').attr('data-visible'));
    jQuery('.scrollableTable').hide();
    jQuery('.scrollable-control[data-slide="prev"]').addClass('disabled');
    jQuery('.scrollableTable th:not(.info), .scrollableTable td:not(.info), .scrollableTable:not(.nohover) td').each(function () {
        jQuery(this).hide();
        jQuery(this).on('hover', function () {
            jQuery(this).toggleClass('on');
            var colnum = jQuery(this).parent('tr').children('.on').index();
            if (colnum > 0) {
                jQuery('.scrollableTable tr').each(function () {
                    jQuery(this).children(':eq(' + colnum + ')').addClass('on');
                });
            } else {
                jQuery('.on').removeClass('on');
            }
        });
    });
    jQuery('.scrollableTable .info').show();

    for (var i = 1; i <= nbvisible; i++) {
        jQuery('.scrollableTable tr').each(function () {
            jQuery(this).children('th:eq(' + i + '), td:eq(' + i + ')').show().addClass('active');
        });
    }
    jQuery('.scrollable-control').on('click', function () {
        /**
         *
         * @type {scrollableTable}
         */
        var button = this;
        jQuery(button).hide();
        jQuery('.scrollableTable tr').each(function () {
            /**
             *
             * @type {scrollableTable}
             */
            var thisLine = this;
            if (jQuery(button).attr('data-slide') == 'next') {
                if (jQuery(this).children('th.active:not(.info), td.active:not(.info)').last().next().length > 0) {
                    jQuery('.scrollable-control[data-slide="prev"]').removeClass('disabled');
                    /**
                     *
                     */
                    var nextObj = jQuery(this).children('th.active:not(.info), td.active:not(.info)').last().next();
                    jQuery(this).children('th.active:not(.info), td.active:not(.info)').first().hide('slide', {direction: "left"}, 'fast', function () {
                        nextObj.show('slide', {direction: "right"}, 'fast').addClass('active');
                        jQuery(button).show(function () {
                            if (jQuery(thisLine).children('.active:not(.info)').last().next().length == 0) {
                                jQuery(button).addClass('disabled');
                            }
                        });
                    }).removeClass('active');
                } else {
                    jQuery(button).addClass('disabled');
                    jQuery(button).show();
                }
            } else {
                if (jQuery(this).children('th.active:not(.info), td.active:not(.info)').first().prevUntil('.info').length > 0) {
                    jQuery('.scrollable-control[data-slide="next"]').removeClass('disabled');
                    /**
                     *
                     */
                    var prevObj = jQuery(this).children('th.active:not(.info), td.active:not(.info)').first().prev();
                    jQuery(this).children('th.active:not(.info), td.active:not(.info)').last().hide('slide', {direction: "right"}, 'fast', function () {
                        prevObj.show('slide', {direction: "left"}, 'fast').addClass('active');
                        jQuery(button).show(function () {
                            if (jQuery(thisLine).children('.active:not(.info)').first().prev(':not(.info)').length == 0) {
                                jQuery(button).addClass('disabled');
                            }
                        });
                    }).removeClass('active');
                } else {
                    jQuery(button).addClass('disabled');
                    jQuery(button).show();
                }
            }
        });
    });

    if (jQuery('.scrollableTable table tbody tr:first-child td:not(.info,.reference)').length < nbvisible) {
        jQuery('.scrollableTable .scrollable-control').hide();
    }

    jQuery('.scrollableTable').show();

    /* Cookie Handler*/
    if ($('.cookie').length) {
        if ($.cookie("bannerCookie") !== "closed") {
            setTimeout(function () {
                $('.cookie').addClass('show');
            }, 1500);
        } else {
            $('.cookie').remove();
        }
        $('.cookie .close').on('click', function () {
            $('.cookie').removeClass('show');
            setTimeout(function () {
                $('.cookie').remove();
            }, 1500);
            $.cookie("bannerCookie", "closed", {expires: 356});
        })
    }

    if ($('.oldBrowsers').length) {
        if ($.cookie("oldBrowsers") !== "closed") {
            $('.oldBrowsers').show();
        } else {
            $('.oldBrowsers').remove();
        }
        $('.oldBrowsers .close').on('click', function () {
            $('.oldBrowsers').remove();
            $.cookie("oldBrowsers", "closed", {expires: 356});
        })
    }
}

/**
 *
 */
function refresh_compare() {
    if ($(".gocompare").length < 2) {
        $(".gocompare").hide();
        $('.zone-compare .btn').hide();
    }
}

// comportement go compare
/**
 *
 * @param maxCheckError
 * @param minCheckError
 */

var selectorsSticky = {
  products : 'products',
  productImage : 'product-image--isnotempty',
  emptyProduct : 'product-image--isempty',
  compareAction : 'actions',
  stickyTitle : 'text'
};
function toggleStickyMobile() {

  var $comparatorSticky = $('.c-sticky-comparator-mobile');
  var $comparatorHeader = $comparatorSticky.find('.c-sticky-comparator-mobile__header');
  var $arrow = $comparatorSticky.find('.svg--arrow-top.toggle');

  var isComparatorOpen = false;

  $comparatorHeader.on('click',function (event) {
    var $this = $arrow;
    if(isComparatorOpen){
      // close it
      $this.closest($comparatorSticky).animate({
        bottom: '-=206px'
      });
      $this
        .removeClass('svg--arrow-bottom')
        .addClass('svg--arrow-top');
    }else{
      // open it
      $this.closest($comparatorSticky).animate({
        bottom: '+=206px'
      });
      $this
        .removeClass('svg--arrow-top')
        .addClass('svg--arrow-bottom');
    }
    isComparatorOpen = !isComparatorOpen;
  });
}


function toggleSticky() {


  var $comparatorSticky = $('.c-sticky-comparator-desktop');
  var $comparatorContent = $('.c-sticky-comparator-desktop__content');
  var $comparatorHeader = $comparatorSticky.find('.c-sticky-comparator-desktop__header');
  var $arrow = $comparatorSticky.find('.svg--arrow-top.toggle');

  var isComparatorOpen = false;

  $comparatorHeader.on('click',function (event) {
    var $this = $arrow;
    if(isComparatorOpen){
      // close it
      $this.closest('.c-sticky-comparator-desktop').animate({
        bottom: '-' + ($comparatorContent.height() || 140) + 'px'
      });
      $this
        .removeClass('svg--arrow-bottom')
        .addClass('svg--arrow-top');
    }else{
      // open it
      $this.closest('.c-sticky-comparator-desktop').animate({
        bottom: 0
      });
      $this
        .removeClass('svg--arrow-top')
        .addClass('svg--arrow-bottom');
    }
    isComparatorOpen = !isComparatorOpen;
  });
}

function buildComparator() {

  var comparingHistory = JSON.parse(localStorage.getItem('COMPARING_HISTORY'));
  var productsCount = comparingHistory.products.length;
  var selectorSticky = isMobile ? '.c-sticky-comparator-mobile' : '.c-sticky-comparator-desktop';
  var max = isMobile ? 2 : 4;
  var newTopCats = [];
  $(selectorSticky + '__' + selectorsSticky.productImage).css('display', 'none');
  $(selectorSticky + '__' + selectorsSticky.emptyProduct).css('display', 'flex');

  if(comparingHistory.products.length >0) {
    $.each(comparingHistory.products, function (key,value) {
      var stickyProduct = $('.product-' + key + ' ' + selectorSticky + '__' + selectorsSticky.productImage + ' img');
      stickyProduct.attr('src', value.productImage);
      stickyProduct.attr('alt', value.productName);
      stickyProduct.attr('title', value.productName);
      $('.product-' + key + ' ' + selectorSticky + '__' + selectorsSticky.emptyProduct).css('display', 'none');
      $('.product-' + key + ' ' + selectorSticky + '__' + selectorsSticky.productImage).css('display', 'flex');
      $('.product-' + key + ' ' + selectorSticky + '__' + selectorsSticky.productImage + ' i').attr('data-productId', value.productID);

      newTopCats = addMissingCats(newTopCats,value.topCategories);
    });
    comparingHistory.categories = newTopCats;
    localStorage.removeItem('COMPARING_HISTORY');
    localStorage.setItem('COMPARING_HISTORY', JSON.stringify(comparingHistory));
  }

  if(productsCount === 1){
    var title = $(selectorSticky + '__' + selectorsSticky.stickyTitle).attr('data-title');
  }
  else{
    var title = $(selectorSticky + '__' + selectorsSticky.stickyTitle).attr('data-multiple-title');
  }
  $(selectorSticky + '__' + selectorsSticky.stickyTitle).html(productsCount + ' /' + max + ' ' + title);

  if(productsCount > 0) {
    if(isMobile) {
      $('.c-sticky-comparator-mobile').css("display", 'flex');
      $('.c-sticky-comparator-desktop').css("display", 'none');
    } else {
      $('.c-sticky-comparator-desktop').css("display", 'flex');
      $('.c-sticky-comparator-mobile').css("display", 'none');
    }
  } else {
    $('.c-sticky-comparator-mobile').css("display", 'none');
    $('.c-sticky-comparator-desktop').css("display", 'none');

  }
}

function refreshCompare() {
  $('.c-sticky-comparator-mobile').css("display", 'none');
  $('.c-sticky-comparator-desktop').css("display", 'none');
  var comparingHistory = localStorage.getItem('COMPARING_HISTORY');
  if(comparingHistory == null) {
    var comparingHistory = {
      category : '',
      categories: [],
      products : []
    };
    comparingHistory = JSON.stringify(comparingHistory);
    localStorage.setItem('COMPARING_HISTORY', comparingHistory);
  }
}

function clearCompare(event) {
  if(event != null) {
    event.preventDefault();
  }
  var oldComparingHistory = JSON.parse(localStorage.getItem('COMPARING_HISTORY'));
  oldComparingHistory.products = [];
  oldComparingHistory.categories = [];
  oldComparingHistory.category = "";
  $('.c-product-thumbnail__compare input[type=checkbox]').prop('checked',false);
  $('.c-product-thumbnail__compare input[type=checkbox]').trigger('change');
  localStorage.setItem('COMPARING_HISTORY', JSON.stringify(oldComparingHistory));
  buildComparator();
}

function deleteProductFromCompare($checked) {
  var oldComparingHistory = JSON.parse(localStorage.getItem('COMPARING_HISTORY'));
  var id = getPropertyValue($checked, "data-analytics-addToComparator-productID");

  if(oldComparingHistory.products.length == 1) {
    clearCompare();
  }else {
    for (var i = 0; i < oldComparingHistory.products.length; i++) {
      if (oldComparingHistory.products[i].productID === id) {
        oldComparingHistory.products.splice(i, 1);
      }
    }
    localStorage.removeItem('COMPARING_HISTORY');
    localStorage.setItem('COMPARING_HISTORY', JSON.stringify(oldComparingHistory));
    buildComparator();
  }
}

function addProductCompare($checked) {
  var comparingHistory = JSON.parse(localStorage.getItem('COMPARING_HISTORY'));
  var oldCategories = comparingHistory.categories;
  var oldCategory = comparingHistory.category;
  var id = getPropertyValue($checked, "data-analytics-addToComparator-productID");
  var name = getPropertyValue($checked, "data-analytics-addToComparator-productName");
  var image = $($checked).parents('.c-product-thumbnail').find('div.c-product-thumbnail__body a img').attr('src');
  var superCategory = getPropertyValue($checked, "data-analytics-addToComparator-productCategory");
  var allOfProductTopCategories = getPropertyValue($checked, "data-analytics-addToComparator-allOfProductTopCat");
  allOfProductTopCategories = allOfProductTopCategories.substring(1,allOfProductTopCategories.length-1).split(',');
  var temp = [];
  $.each(allOfProductTopCategories,function () {
    temp.push($.trim(this));
  })
  allOfProductTopCategories = temp;
  var max = isMobile ? 2 : 4;

  if(comparingHistory.products.length >= max && oldCategories.includes(superCategory)) {
    $checked.prop('checked', false);
    $checked.parent().removeClass("checkOn").addClass("checkOff");
    $('#toast-notification').removeClass('is-done');
    $('#toast-notification .message-limit-product').html(
      comparatorMaximumNumberOfProductsReached.replace('{0}', comparingHistory.products.length)
    );
    myFunction();
  }else{
    var comparedProduct = {
      'productID' : id,
      'productName' : name,
      'productImage': image,
      'topCategories' : allOfProductTopCategories
    }

    sendEvent('addToComparator', comparedProduct);

    if(oldCategories == null || !hasCommonCat(oldCategories,allOfProductTopCategories)) {
      comparingHistory = {
        category : superCategory,
        categories: allOfProductTopCategories,
        products : [
          comparedProduct
        ]
      };
    } else {
      comparingHistory.products.push(comparedProduct);
      comparingHistory.categories = addMissingCats(oldCategories,allOfProductTopCategories);
    }
    $('#toast-notification').addClass('is-done');
    $('#toast-notification .message-limit-product').html(
      comparatorProductAdded.replace('{0}', $checked.attr('data-analytics-addToComparator-productName'))
    );
    myFunction();
    localStorage.setItem('COMPARING_HISTORY', JSON.stringify(comparingHistory));
    buildComparator();
  }
}

function hasCommonCat(haystack, arr) {
  return arr.some(function (v) {
    return haystack.indexOf(v) >= 0;
  });
}

function addMissingCats(a,b) {
  if(b === undefined || b.length == 0) return a;
  return a.concat(b.filter(function(item){
    return a.indexOf(item) < 0;
  }));
}

function myFunction() {
  // Get the snackbar DIV
  //var x = document.getElementById('toast-notification');
  var toastNotification = $('#toast-notification');

  // Add the 'show' class to DIV
  //x.className = 'show';
  toastNotification.addClass('show');

  //setTimeout(function(){ x.className = x.className.replace('show', ''); }, 3000);
  // After 3 seconds, remove the show class from DIV
  setTimeout( function(){toastNotification.removeClass('show');}, 3000);
}

function deleteProduct() {
  var productId = $(this).attr('data-productId');
  var oldComparingHistory = JSON.parse(localStorage.getItem('COMPARING_HISTORY'));
  if(oldComparingHistory.products.length == 1) {
    clearCompare();
  }else {
    for(var i=0; i < oldComparingHistory.products.length; i++) {
      if(oldComparingHistory.products[i].productID === productId) {
        oldComparingHistory.products.splice(i,1);
        $('.c-product-thumbnail__compare input[type=checkbox][data-analytics-addtocomparator-productid="' + productId +'"]').prop('checked',false);
        $('.c-product-thumbnail__compare input[type=checkbox][data-analytics-addtocomparator-productid="' + productId +'"]').trigger('change');
      }
    }
    localStorage.removeItem('COMPARING_HISTORY');
    localStorage.setItem('COMPARING_HISTORY', JSON.stringify(oldComparingHistory));
    buildComparator();
  }
}
function initGoCompare() {
    // countCompare();

    if (!isMobile) {
        $('.gocompareBtn').hide('fast');
    } else if (isMobile && countGoCompare() > 1 && $('.c-sticky-comparator-desktop').length == 0 && $('.c-sticky-comparator-mobile').length == 0) {
        $('.gocompareBtn').show('fast');
    }

    if($('.c-sticky-comparator-desktop').length == 0 && $('.c-sticky-comparator-mobile').length == 0){
      jQuery('.gocompare')
        .each(
          function () {
            if ((jQuery(this).children('input').is(':checked'))
              && (jQuery('.gocompare input[type=checkbox]:checked').length > 1)) {
              jQuery(this).addClass('active');
            } else {
              jQuery(this).removeClass('active');
            }
          });
    }


    jQuery('.gocompare input[type=checkbox]').on('click',
        function () {
            if($('.c-sticky-comparator-desktop').length > 0 || $('.c-sticky-comparator-mobile').length > 0){
              if($(this).is(':checked')) {
                if ((!isMobile && countGoCompare() > 4) || (isMobile && countGoCompare() > 2)) {
                  if (isMobile) {
                    maxCheckError = maxCheckError.replace("4", "2");
                  }
                  $("#ModalMessage .modal-body").html(
                    '<p>' + maxCheckError + '</p>');
                  $("#ModalMessage").show();
                  $("#ModalMessage").modal();
                  $("#ModalMessage").on('hidden.bs.modal', function () {
                    $("#ModalMessage .modal-body").html("");
                    $("#ModalMessage").removeClass("modal-business");
                  });
                  buildComparator();
                  return false;
                }
              }
            }else {
              if ((!isMobile && countGoCompare() < 5) || (isMobile && countGoCompare() < 3)) {
                playGoCompare(jQuery(this));
              } else {
                if (isMobile) {
                  maxCheckError = maxCheckError.replace("4", "2");
                }
                $("#ModalMessage .modal-body").html(
                  '<p>' + maxCheckError + '</p>');
                $("#ModalMessage").show();
                $("#ModalMessage").modal();
                $("#ModalMessage").on('hidden.bs.modal', function () {
                  $("#ModalMessage .modal-body").html("");
                  $("#ModalMessage").removeClass("modal-business");
                });
                return false;
              }
              $(".gocompare input[type=checkbox]").trigger("check");
            }
        });
}

function countGoCompare() {
  if($('.c-sticky-comparator-desktop').length > 0 || $('.c-sticky-comparator-mobile').length > 0){
    refreshCompare();
    var comparingHistory = JSON.parse(localStorage.getItem('COMPARING_HISTORY'));
    var oldCategory = comparingHistory.category;
    var oldCategories = comparingHistory.categories;
    var superCategory = $('input[data-analytics-addToComparator-productCategory]').attr('data-analytics-addToComparator-productCategory')
    if(oldCategories.includes(superCategory)) {
      return comparingHistory.products.length + 1;
    } else {
      return 1;
    }
  }else{
    return jQuery('.gocompare input[type=checkbox]:checked').length;
  }
}

function playGoCompare(checkbox) {
    var comparingHistory = JSON.parse(localStorage.getItem('COMPARING_HISTORY'));
    var condition = ($('.c-sticky-comparator-desktop').length > 0 || $('.c-sticky-comparator-mobile').length > 0)?
      (comparingHistory.products.length > 1):(jQuery('.gocompare input[type=checkbox]:checked').length > 1);
    if (checkbox.is(':checked')) {
        if (condition) {
            checkbox.parent('label').addClass('active');
            jQuery('.gocompare input[type=checkbox]:checked').parent('label')
                .addClass('active');
            if (isMobile) {
                $('.gocompareBtn').show('fast');
            }
        } else {
            jQuery('.gocompare input[type=checkbox]:checked').parent('label')
                .removeClass('active');
            $('.gocompareBtn').hide('fast');
        }
    } else {
        // checkbox.parent('label').removeClass('active');
        if (condition) {
            jQuery('.gocompare input[type=checkbox]:checked').parent('label')
                .addClass('active');
            if (isMobile) {
                $('.gocompareBtn').show('fast');
            }
        } else {
            jQuery('.gocompare input[type=checkbox]:checked').parent('label')
                .removeClass('active');
            $('.gocompareBtn').hide('fast');
        }
        checkbox.parent('label').removeClass('active');
    }
}

/**
 *
 * @param msg
 * @param type
 * @returns {boolean}
 */
function notification(msg, type) {
    $('#globalMessages').empty().append("<div class='information_message " + type + "'><span class='single'></span><p>" + msg + "</p></div>");
    $('html,body').animate({
        scrollTop: $('#globalMessages').offset().top - 63
    }, 500);
    return false;
}

/**
 *
 */
function killNotification() {
    $('#globalMessages').empty();
}

/* Autocomplete Highlight function */
function HighlightAutocomplete() {
    $.ui.autocomplete.prototype._renderItem = function (ul, item) {
        /**
         *
         * @type {RegExp}
         */
        var re = new RegExp("^" + this.term, "i");

        /**
         *
         */
        var t = item.label.replace(re, "<span style='font-weight:bold;'>" + this.term + "</span>");
        return $("<li></li>").data("item.autocomplete", item).append("<a>" + t + "</a>").appendTo(ul);
    };
}


/* Only on IE 8 */
function IE() {
    $('.mymoulinex-slider .item').each(function (index) {
        $(this).addClass('nth-child-' + parseInt(index + 1))
    })
}


/* Loader Handler */
/**
 *
 */
function hideLoader() {
    $('.loader').fadeOut("fast", function () {
        $('.loader').css('display', 'none');
    });
}

/**
 *
 */
function showLoader() {
    $('.loader').css('display', 'block').fadeIn("slow");
}

/**
 *
 */
function nlReset() {
    showLoader();
    $('.nl-submit').addClass('inactive');
    $('.nl-submit-wrap').show();
    $('.more', $('.humeur')).hide();
    $('.social-share', $('.humeur')).hide();
    $('.result-form').empty();
    hideLoader();
    $('html,body').animate({
        scrollTop: $('.humeur').offset().top - 63
    }, 500);
    $('.nl-field-toggle').each(function () {
        $(this).html('&nbsp;');
    });
    $('select', $('.nl-form')).each(function () {
        $(this).prop('selectedIndex', 0);
    });
}

/**
 *
 * @param form
 * @param update
 */
function incrementQuantity(form, update) {
    /**
     *
     */
    var obj = jQuery(form).find('#quantity');

    /**
     *
     * @type {Number}
     */
    var qty = parseInt(obj.val());
    obj.val(qty + 1);
    if (update == true) {
        jQuery(form).trigger('submit');
    }
}

/**
 *
 * @param form
 * @param update
 */
function decrementQuantity(form, update) {
    /**
     *
     */
    var obj = jQuery(form).find('#quantity');

    /**
     *
     * @type {Number}
     */
    var qty = parseInt(obj.val());
    if (qty > 1) {
        obj.val(qty - 1);
        if (update == true) {
            jQuery(form).trigger('submit');
        }
    }
}

/**
 *
 * @param form
 * @param max
 * @param update
 */
function incrementQuantityForAcc(form, max, update) {
    /**
     *
     */
    var obj = jQuery(form).find('#qty');

    /**
     *
     * @type {Number}
     */
    var qty = parseInt(obj.val());
    if (qty < max) {
        obj.val(qty + 1);
        if (update == true) {
            jQuery(form).trigger('submit');
        }
    } else {
        jQuery(form).find('#msg_error').show();
    }
}

/**
 *
 * @param form
 * @param update
 */
function decrementQuantityForAcc(form, update) {
    /**
     *
     */
    var obj = jQuery(form).find('#qty');

    /**
     *
     * @type {Number}
     */
    var qty = parseInt(obj.val());
    jQuery(form).find('#msg_error').hide();
    if (qty > 1) {
        obj.val(qty - 1);
        if (update == true) {
            jQuery(form).trigger('submit');
        }
    }
}

/**
 *
 * @param msg
 */
function confirmDeleteEntry(msg) {
    return confirm(msg);
}

/**
 *
 */
function handleMoulisearchLoad() {
    $(document).on('click', '.wrap-product-list .show-more a', function (event) {
        $('.show-more').hide();
        event.preventDefault();
        /**
         *
         * @type {*|jQuery}
         */
        var url = $(this).attr("href");
        showLoader();
        $.ajax({
          url: url,
          type: 'GET',
          dataType: 'html',
          data: ''
        }).always(function (data) {
          $('.product-list').append(data);
          hideLoader();
        });
    });
}

/**
 *
 * @param obj
 * @constructor
 */
function LoadMore(obj) {
    jQuery(obj).parents('.see-more').hide();
    jQuery.ajax({
        url: jQuery(obj).attr('href')
    }).done(function (html) {
        jQuery(obj).parents(".list-content").find(".item").remove();
        jQuery(obj).parents(".list-content").html(html);
        initGoCompare();
        refresh_compare();
    });
}

/**
 * ajax for load more results for search single and multiple
 * @param obj
 * @param seeAll
 * @param idName
 * @constructor
 */
function LoadMoreResults(obj, seeAll, idName) {
    seeAll = typeof seeAll !== 'undefined' ? seeAll : false;
    jQuery(obj).parents('.see-more').remove();
    /**
     *
     * @type {string}
     */
    var id = '#' + idName;
    if (seeAll == true) {
        jQuery.ajax({
            url: jQuery(obj).attr('href')
        }).done(function (html) {
            $(id).html(html).slideDown('slow', 'linear');
        });
    } else {
        jQuery.ajax({
            url: jQuery(obj).attr('href')
        }).done(function (html) {
            $(id).html($(id).html() + html).slideDown('slow', 'linear');
        });
    }
}

$('.product-comparator .close').on('click', function () {
    /**
     *
     * @type {number}
     */
    var i = 0;
    $('.scrollableTable tr th').each(function () {
        i++;
    });
    if (i > 3) {
        /**
         *
         * @type {*|jQuery}
         */
        var colnum = $(this).parent().parent().index();
        if (colnum > 0) {
            $('.scrollableTable tr').each(function () {
                $(this).children(':eq(' + colnum + ')').remove();
            });
        }
        if (i == 4) {
            $('.scrollableTable .close').fadeOut();
        }
    }
});

function hideClassificationInrRowFilterMode() {
  $('.product-comparator #ScrollabeTableCompare tr.comparison').each(function(){
    var first = $(this);
    var next = first.next();
    var count = 0;
    while(next.length>0 && !next.hasClass("comparison")) {
      if(!next.hasClass("ressemblant")) {
        count++;
      }
      next = next.next();
    }
    if(count === 0) {
      first.hide();
    }
  });
}

$('.product-comparator .facet_block-label input').on('change', function () {
    /**
     *
     * @type {number|jQuery}
     */
    var is_checked = $(".product-comparator .facet_block-label input:checked").length;
    if (is_checked == 0) {
        $('.product-comparator #ScrollabeTableCompare tr').show();
    }
    else {
        $('.product-comparator #ScrollabeTableCompare tr.ressemblant').hide();
        hideClassificationInrRowFilterMode();
    }
});

/**
 *
 */
function bindForm() {
    $('#new_address_form').on('change', function () {
        /**
         *
         * @type {*|jQuery}
         */
        var url_address = $("#add-address-button").attr("data-ajax");

        /**
         *
         * @type {*|jQuery}
         */
        var isoCode = $('#new_address_form').val();
        jQuery.ajax({
            type: "GET",
            url: url_address,
            data: {country: isoCode}
        }).done(function (data) {
            $('#AddressManager').html(data);
            bindForm();
        }).always(function (data) {
            jQuery('#AddressManager').slideDown();
        });
    });
}

// BRA -1273 : upgrade companion

/**
 *
 */
function validateCompatibiliteCompanion() {
    $(".compatibilite-comp-par2").show();
    $(".validate-compatibilite-comp-btn").first().hide();
    initializeDatePicker();
}

/**
 *
 * @param idModalMessage
 */
function closeModalMessage(idModalMessage) {
    $('#' + idModalMessage).modal('hide');
}

/**
 *
 * @param event
 */
function validateCompatibiliteCompanionForm(event) {
    hasError = false;
    if ($('#dateCollecte').val() != '') {
        $("#upgrade-comp-date-collecte-required").hide();
    } else {
        $("#upgrade-comp-date-collecte-required").show();
        hasError = true;
    }

    if ($('#dateRetour').val() != '') {
        $("#upgrade-comp-date-retour-required").hide();
    } else {
        $("#upgrade-comp-date-retour-required").show();
        hasError = true;
    }

    if ($('#mobile').val() != '') {
        $("#upgrade-comp-mobile-required").hide();
        if (document.getElementById('mobile').validity.valid) {
            $("#upgrade-comp-mobile-invalide").hide();
        }
        else {
            hasError = true;
            $("#upgrade-comp-mobile-invalide").show();
        }
    }
    else {
        $("#upgrade-comp-mobile-invalide").hide();
        $("#upgrade-comp-mobile-required").show();
        hasError = true;
    }

    if (!hasError) {
        $.ajax({
            type: $("#upgradeCompanionForm").attr('method'),
            data: $("#upgradeCompanionForm").serialize(),
            url: $("#upgradeCompanionForm").attr('action')
        }).done(function (data) {
            //si la validation des dates + mobile est effectu� avec succes il faut ajouter le produit au panier
            closeModalMessage('ModalMessage');
            // ce test est ajout� pour v�rifeir que entre temps aucun produit n'est ajout� au panier
            if (data == true) {
                $.ajax({
                    type: $(".companion-add-to-cart-form").attr('method'),
                    data: $(".companion-add-to-cart-form").serialize(),
                    url: $(".companion-add-to-cart-form").attr('action')
                }).done(ACC.product.displayAddToCartPopup).fail( function (cartResult, statusText, xhr, formElement) {
                    console.error("Error with add to cart response :" + statusText);
                });
            }
            else {
                console.error("produit n'est pas cumulable");
            }
        }).fail(function () {
            console.error("Error upgradeCompanionForm ");
        });
    }
}

/**
 *
 * @param obj
 */
function gsebAddressManager(obj) {
    $('#AddressManager').slideUp('fast', function () {
        /**
         *
         * @type {*|jQuery}
         */
        var url_address = $(obj).attr('data-ajax');
        $.ajax({
            type: "GET",
            url: url_address
        }).done(function (data) {
            try {
                data = JSON.parse(data)
            } catch (e) {
                //Temporary FIX for malformed JSON with escape single quotes
                data = data.replace(/\\'/g, "'");
                try {
                    data = JSON.parse(data);

                } catch (e) {
                    //console.log("Parse JSON ERROR");
                }
            }
            $('#AddressManager').html(data.validatedForm);
            bindForm();
            bindCreateUpdateAddress();
        }).always( function (data) {
            $('#AddressManager').show();
            scrollToParam('#AddressManager');
        });
    });
}

/**
 *
 */
function bindCreateUpdateAddress() {
    $('.create_update_address_form').on('submit', function(event){
        event.preventDefault();
        $.ajax({
            url: ACC.config.contextPath + $(this).prop('action'),
            data: $(this).serialize() + '&' + $(this).find("button[type=submit]").prop('name'),
            method: $(this).prop('method')
        }).done(function (data) {
            var data = data;
            try {
                data = JSON.parse(data)
            } catch (e) {
                //Temporary FIX for malformed JSON with escape single quotes
                data = data.replace(/\\'/g, "'");
                try {
                    data = JSON.parse(data);

                } catch (e) {
                    //console.log("Parse JSON ERROR");
                }
            }
            $(".addrFormContainer").html(data.validatedForm);
            $("#globalMessages").html(data.message);
            bindCreateUpdateAddress();
            if (data.success == 'true') {
                var addEditText=$(".addressAddEditTxt").clone();
                $(".addrBookContainer").html(data.addrBook);
                $(".addrBookContainer").prepend($(addEditText));
                closeGsebAddressManager();
            }
        });

    });
}

/**
 *
 * @param param
 */
function scrollToParam(param) {
    /**
     *
     * @type {Number}
     */
    var place = parseInt($(param).offset().top);
    $('html,body').animate({
        scrollTop: place - 63 // -63 pour prendre en compte le header fixe
    }, 600);
}

/**
 *
 */
function closeGsebAddressManager() {
    scrollToParam('body');
    $('#AddressManager').html("");
    appendDeliveryAddress();
    appednAddrBookContainer();
}

/**
 *
 */
function closeAddressManager() {
    $('#AddressManager').slideUp();
}

/**
 *
 * @param obj
 * @param msg
 */
function confirmDelete(obj, msg) {
    if (confirm(msg)) {
        alert('you accept : reload the page.');
        return true;
    }
    return false;
}

$("#FormNewsLetter").on('submit', function (event) {
    event.preventDefault();
});

/**
 *
 */
function showNewsLetterModalIncheckoutPage() {
    $(".skip[id^=error]").hide();
	/**
    *
    * @type {boolean}
    */
   var termsNotChecked = !jQuery('#rules').is(':checked');

   /**
    *
    * @type {boolean}
    */
   var paymentNotChecked = !jQuery('input[id^=payment-mode-]').is(':checked');

   /**
    *
    * @type {boolean}
    */
   var stopProcessing = false;
   if (termsNotChecked) {
       jQuery('#errorTOS').show();
       stopProcessing = true;
   } else {
       jQuery('#errorTOS').hide();
   }

   if (isSampleOrder===false && paymentNotChecked) {
       jQuery('#errorPM').show();
       stopProcessing = true;
   } else {
       jQuery('#errorPM').hide();
   }

   if ($('#detachedPieceCG').length > 0 && !$('#detachedPieceCG').is(':checked')) {
       $('#errorCG-PD').show();
       stopProcessing = true;
   } else {
       $('#errorCG-PD').hide();
   }

   if ($('#repareServiceCG').length > 0 && !$('#repareServiceCG').is(':checked')) {
       $('#errorCG-RS').show();
       stopProcessing = true;
   } else {
       $('#errorCG-RS').hide();
   }
   if(!validateLegalTax()){
   	stopProcessing=true;
   }
    if(!validateMobilePhone()){
        stopProcessing=true;
    }

   if (stopProcessing) {
       return;
   }
   $('#ModalNewsLetter').modal();
   Modal.show();
}

//Show Paylib message
$("#FormPaymentMode input[type=radio][id*=payment-mode-]").on('click', function () {
    if ($("#FormPaymentMode input[type=radio][id*=payment-mode-][value*=paylib]").is(':checked'))
        $("#paylibMessage").show();
    else
        $("#paylibMessage").hide();
});

/**
 *
 * @param url
 */

function submitNewsletter(){
	$.ajax({
        type: $("#FormNewsLetter").attr('method'),
        data: $("#FormNewsLetter").serialize(),
        url: $("#FormNewsLetter").attr('action')
    }).done(function (data) {
        if(data == "ok") {
            $("#popinMessages").append("<div class='information_message positive'> <span class='single'></span> <span> "+newsLEtterSubscribeEmail+"</span> </div>");
            $("#FormNewsLetter .item-form-news").remove();
            $("#DoubleOptinButton").remove();
            $("#DoubleOptinButtonClose").show("#DoubleOptinButton");
        }else {
            $("#DoubleOptinButtonClose").trigger('click');
        }
    }).fail( function () {
        $('#errorSubscription').show();
    });
    $("#FormNewsLetter").trigger('submit');
}


function validateTOSForDoubleOptin(url) {
    $(".skip[id^=error]").hide();
	if ($('#rules').is(':checked') && ( $('#detachedPieceCG').length <= 0 || $('#detachedPieceCG').is(':checked')) && ($('#repareServiceCG').length <= 0 || $('#repareServiceCG').is(':checked')) && (jQuery('input[id^=payment-mode-]').length <= 0 || jQuery('input[id^=payment-mode-]').is(':checked')) && validateLegalTax() && validateMobilePhone()) {

    	if(isSampleOrder===true){
        	placeSmapleOrder();
        }else{
         validateTOSAjaxService(url);
        }
    } else {
        if (!$('#rules').is(':checked')) {
            $('#errorTOS').show();
        } else {
            $('#errorTOS').hide();
        }
        if ($('#detachedPieceCG').length > 0 && !$('#detachedPieceCG').is(':checked')) {
            $('#errorCG-PD').show();
        } else {
            $('#errorCG-PD').hide();
        }
        if ($('#repareServiceCG').length > 0 && !$('#repareServiceCG').is(':checked')) {
            $('#errorCG-RS').show();
        } else {
            $('#errorCG-RS').hide();
        }
        if(jQuery('input[id^=payment-mode-]').length > 0 && !jQuery('input[id^=payment-mode-]').is(':checked')) {
            jQuery('#errorPM').show();
        }
        validateLegalTax();
        validateMobilePhone();
        if(isSampleOrder===false){
            var legalTaxNumber=$("#legal-tax-number").val();
            var legalTaxNumberData=typeof legalTaxNumber !== 'undefined'?"&legal-tax-number="+legalTaxNumber:'';
            var mobilePhone = $("#mobilePhone").val();
            var mobilePhoneData = typeof mobilePhone !== 'undefined' ? "&mobilePhone="+mobilePhone : '';
        	$.ajax({
            type: "post",
            data: $("#FormPaymentMode").serialize()+legalTaxNumberData+mobilePhoneData,
            url: url
        }).done(function (data) {
                $('#errorPM').hide();
            }).fail(function () {
                $('#errorPM').show();
            });
        }
    }
    $('#ModalNewsLetter').find('.close').trigger("click");
}


function validateTOS(url) {
    $(".skip[id^=error]").hide();
	if ($('#rules').is(':checked') && ( $('#detachedPieceCG').length <= 0 || $('#detachedPieceCG').is(':checked')) && ($('#repareServiceCG').length <= 0 || $('#repareServiceCG').is(':checked')) && (jQuery('input[id^=payment-mode-]').length <= 0 || jQuery('input[id^=payment-mode-]').is(':checked')) && validateLegalTax() && validateMobilePhone()) {
        /*il faut d'abord verifier si la case � cocher existe avant de v�rfier s'il est coch�e
         * parce que cette case � cocher n'apparait sauf si il y'a un produit de type X
         */
        //update news letter data
    	 $.ajax({
             type: $("#FormNewsLetter").attr('method'),
             data: $("#FormNewsLetter").serialize(),
             url: $("#FormNewsLetter").attr('action')
         });
         $("#FormNewsLetter").trigger('submit');
        //go create the order
        if(isSampleOrder===true){
        	placeSmapleOrder();
        }else{
         validateTOSAjaxService(url);
        }
    } else {
        if (!$('#rules').is(':checked')) {
            $('#errorTOS').show();
        } else {
            $('#errorTOS').hide();
        }
        if ($('#detachedPieceCG').length > 0 && !$('#detachedPieceCG').is(':checked')) {
            $('#errorCG-PD').show();
        } else {
            $('#errorCG-PD').hide();
        }
        if ($('#repareServiceCG').length > 0 && !$('#repareServiceCG').is(':checked')) {
            $('#errorCG-RS').show();
        } else {
            $('#errorCG-RS').hide();
        }
        if(jQuery('input[id^=payment-mode-]').length > 0 && !jQuery('input[id^=payment-mode-]').is(':checked')) {
            jQuery('#errorPM').show();
        }
        validateLegalTax();
        validateMobilePhone();
    }
    $('#ModalNewsLetter').find('.close').trigger("click");
}

/**
 *
 */
function validateFormDetachedPiece() {
    if ($('#accessoryCode').val() != '') {
        $.ajax({
            type: $("#detachedPieceForm").attr('method'),
            data: $("#detachedPieceForm").serialize(),
            url: $("#detachedPieceForm").attr('action')
            // valider le formulaire
        }).done( function (data) {	//si l'action cot� serveur se termine corr�ctement
            /*
             * si le code cat�gorisation diff�rent de "S" : Le client est redirig� vers la page d�tail produit de la pi�ce de rechange.
             *	La page d�tail de la pi�ce de rechange est identique � la page d'affichage d'un accessoire.
             */
            if (data != null && data != '') {
                if (data.accessoryCategorisation != 'S') {
                    window.location.href = ACC.config.contextPath + data.url;
                } else {
                    $('#errorNofound').hide();
                    $('#errorNotForSale').show();

                    $('#modalErrorDetachedPiece').modal();
                    Modal.show();
                }
            } else {
                $('#errorNotForSale').hide();
                $('#errorNofound').show();

                $('#modalErrorDetachedPiece').modal();
                Modal.show();
            }
        }).fail(function () {

            $('#errorNotForSale').hide();
            $('#errorNofound').show();

            $('#modalErrorDetachedPiece').modal();
            Modal.show();
        });
    }
    else {
        $('#errorNotForSale').hide();
        $('#errorNofound').hide();
        $('#errorRequired').show();
    }
}

// fonction ajout� pour handler le click sur le bouton entrer dans le formulaire de recherche des pieces detach�es
$("#detachedPieceForm").on('submit', function (event) {
    validateFormDetachedPiece();
    event.preventDefault();
});

/**
 *
 */
function validateFormExplodedView() {
    if ($('#codeSav').val() != '') {
        if (document.getElementById('codeSav').validity.valid) {
            $('#errorInvalid').hide();
            $.ajax({
                type: $("#explodedViewsForm").attr('method'),
                data: $("#explodedViewsForm").serialize(),
                url: $("#explodedViewsForm").attr('action')
                // valider le formulaire
            }).done(function (data) {	//si l'action cot� serveur se termine corr�ctement
                //si la fonction return le code du Media exploded view on red�rige vers la fonction qui va afficher la page de la vue eclat�e
                if (data != null && data != '') {
                    //exploded-view/codeProduct/detail-exp-view/codeSAv
                    window.location.href = ACC.config.contextPath + "/exploded-view/" + $('#productCodePost').val() + "/detail-exp-view/" + data;
                }
                else {
                    $('#errorRequired').hide();
                    $('#errorNofound').show();
                }
            }).fail( function () {
                $('#errorRequired').hide();
                $('#errorNofound').show();
            });
        } else {
            $('#errorRequired').hide();
            $('#errorInvalid').show();
        }
    }
    else {
        $('#errorNofound').hide();
        $('#errorInvalid').hide();
        $('#errorRequired').show();
    }
}

$("#explodedViewsForm").on('submit', function (event) {
    validateFormExplodedView();
    event.preventDefault();
});


/**
 *
 * @param myPoint
 */
function gotoPoint(myPoint, posName) {
    google.maps.event.addListenerOnce(map, 'center_changed', function(event) {
        //set a minimum zoom
        // if you got only 1 marker or all markers are on the same spot
        if (this.getZoom() > 13) {
            this.setZoom(13);
        }
    });
    map.setCenter(new google.maps.LatLng(locations[myPoint][2], locations[myPoint][3]));
    setTimeout(function () {
        markerCollection[myPoint].setAnimation(null);
    }, '5000');
    for (j = 0; j < locations.length; j++) {
        markerCollection[j].setAnimation(null);
    }
    if (markerCollection[myPoint].getAnimation() != null) {
        markerCollection[myPoint].setAnimation(null);
    } else {
        markerCollection[myPoint].setAnimation(google.maps.Animation.BOUNCE);
    }
    showDetails(posName);
    redimensionnerStore('#StoreLocator .details-store-off:visible');
}


/**
 *
 * @param selecteur
 */
function redimensionnerStore(selecteur) {
    /**
     *
     * @type {number}
     */
    var hauteur = 0;
    $(selecteur).each(function () {
        if ($(this).height() > hauteur) hauteur = $(this).height();
    });
    $(selecteur).each(function () {
        $(this).height(hauteur);
    });
}

/**
 *
 * @param reCaptchaPubKey
 * @param id
 */
function createReCaptcha(reCaptchaPubKey, id) {
    Recaptcha.create(reCaptchaPubKey, id, {
        theme: "clean"
    });
}

if ($(".a2a_dd")) {
    /**
     *
     * @type {{}|a2a_config|{}|a2a_config}
     */
    var a2a_config = a2a_config || {};
    a2a_config.onclick = 1;
    a2a_config.prioritize = ["facebook", "twitter", "linkedin",
        "google_plus", "pinterest", "tumblr", "myspace", "email",
        "google_bookmarks", "yahoo_bookmarks"];
    a2a_config.num_services = 10;
    a2a_config.color_main = "D7E5ED";
    a2a_config.color_border = "D7E5ED";
    a2a_config.color_link_text = "373332";
    a2a_config.color_link_text_hover = "373332";
    (function (d, t) {
        var g = d.createElement(t), s = d.getElementsByTagName(t)[0];
        g.src = '//static.addtoany.com/menu/page.js';
        s.parentNode.insertBefore(g, s);
    }(document, 'script'));
}

/**
 *
 */
var Field = (function () {
    /**
     * Constructor
     * @param name
     * @param order
     * @param type
     * @param rules
     * @param visible
     */
    var cls = function (name, order, type, rules, visible) {
        this.name = name; // Name of field
        this.order = order; // Dropdown lists steps values combination
        this.type = type; // Profile name
        this.rules = rules; // validation rules
        this.visible = visible; // is field visible by default
    };
    // Public methods
    cls.prototype = {
        getName: function () {
            return this.name;
        },
        getOrder: function () {
            return this.order;
        },
        getRules: function () {
            return this.rules;
        },
        isVisible: function () {
            return this.visible;
        },
        isMandatory: function () {
            return this.rules.indexOf("equired") >= 0;
        }
    };
    return cls;
})();

/* BRA-3294 */
$('#AccordionFAQ .accordion-toggle').on('click', function () {
    $('#faq #widget2').attr('width', '100%');
});
/* BRA-3294 */

$(function () {
    if ($('body').hasClass('page-productDetails') && $(document).width() < 720) {
        /**
         * get product details page modal
         * @type {*|jQuery|HTMLElement}
         */
        var modal = $('.page-productDetails #ModalMedia');

        // register to 'shown' and 'hidden' modal events
        modal.on('shown', function () {
            cbModalShown();
        });
        modal.on('hidden', function () {
            cbModalHidden();
        });
        // register to onSlideBefore bxSlider event
        $(document).on('OnSlideBefore', function () {
            cbOnSlideBefore();
        });
        /**
         * modal shown callback
         */
        function cbModalShown() {
            processItems();
        }

        /**
         * modal hidden callback
         */
        function cbModalHidden() {
        }

        /**
         * click on the video overlay callback
         * @param overlay
         */
        function cbClickVideoOverlay(overlay) {
            /**
             *
             * @type {*|jQuery|HTMLElement}
             * @private
             */
            var _overlay = $(overlay);

            /**
             *
             */
            var iframe = _overlay.prev();
            _overlay.remove();
            // trigger click on play button
            iframe.attr('src', iframe.attr('src') + '&autoplay=1');
        }

        /**
         * onSlideBefore event handler
         */
        function cbOnSlideBefore() {
            processItems();
        }

        /**
         * process items
         */
        function processItems() {
            /**
             * get all modal items
             * @type {*|jQuery|HTMLElement}
             */
            var items = $('#CarouselDetailProductModal .item');
            // loop through each item
            items.each(function () {
                item = $(this);
                iframe = item.find('iframe').first();
                if (iframe.length === 1) {
                    // if item contain an iframe
                    item.addClass('item-alt');
                    // add item-alt class to the item
                    iframe.addClass('iframe-alt');
                    // add iframe-alt class to the iframe
                    if (item.find('.video-overlay').length === 0) {
                        item.append('<span class = "video-overlay" style="width:100%;height:100%;background:#000000;z-index:9999;top:0;left:0;opacity:0;position:absolute"></span>');
                        // append overlay to the iframe
                    }
                    item.find('.video-overlay').on('click', function () {
                        cbClickVideoOverlay(this);
                    });
                }
            });
        }
    }
});

/**
 *
 */
$(function () {
    $('.list-recipe .show-more').show();
    $('.list-recipe .seo-show-more').attr('style', "display:none;");

});

/*Nav bar product details*/
$(window).on('scroll', function () {
    /**
     *
     * @type {*|jQuery}
     */
    var position = $(window).scrollTop();

    /**
     *
     */
    var positionToFixeIn = $("#product-benefits").outerHeight() + $("#master-detail-product").outerHeight();
    if($("#productGammes").length) {
        positionToFixeIn+= $("#productGammes").outerHeight();
    }
    if($("#delivery-engagement").length) {
      positionToFixeIn+= $("#delivery-engagement").outerHeight();
    }
    if ($(window).width() > 720) {
        positionToFixeIn += $(".wrap-header").outerHeight();
    }

    /**
     *
     * @type {number}
     */
    var postionTop = position - 120,
        postionDown = position + 135;
    if ($('.nav_lame').outerHeight() > 116) {
        postionTop = position - 191;
        postionDown = position + 206;
    }
    $('.nav_lame a').each(function () {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var currLink = $(this);

        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top < postionDown && refElement.position().top + refElement.height() > postionTop) {
            $('.nav_lame  li a').removeClass("active");
            currLink.addClass("active");
        }
        else {
            currLink.removeClass("active");
        }
    });
    $('.nav_lame a:first').each(function () {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var currLink = $(this);

        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top + refElement.height() > position - 70) {
            $('.nav_lame  li a').removeClass("active");
            currLink.addClass("active");
        }
    });

    if (position >= positionToFixeIn) {
        $(".nav_lame").addClass("fixed");
        if ($('.nav_lame').outerHeight() > 116)
            $("#product-description").addClass("padding-desc-mobile");
        else
            $("#product-description").addClass("padding-desc");
    }
    else {
        $(".nav_lame").removeClass("fixed");
        $("#product-description").removeClass("padding-desc");
        $("#product-description").removeClass("padding-desc-mobile");
    }
});

// SCROLL on anchor click
$('.nav_lame li a').on('click', function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
            /**
             *
             * @type {number}
             */
            var scrollTopp = target.offset().top - 120;
            if ($('.nav_lame').outerHeight() > 116)
                scrollTopp = target.offset().top - 191;
            $('html,body').animate({
                scrollTop: scrollTopp
            }, 900);
            return false;
        }
    }
});

/* start : BRA-5347 */
$('a.category-name:not(".direct-link")').on('click', function () {
    var notActive = $(this).hasClass('notActive');
    if (notActive) {
        $('a.category-name').addClass('notActive');
        $('a.category-name').addClass('notSelected');
        $('.subCategory').hide('slow');
        var targetIndex = $(this).attr("data");
        $("#subCategory" + targetIndex).show('slow');
        $(this).removeClass('notActive');
        $(this).removeClass('notSelected');
        $(this).closest("section").addClass('opened');
    } else {
        $('a.category-name').addClass('notActive');
        $('a.category-name').removeClass('notSelected');
        $('.subCategory').hide('slow');
        $(this).closest("section").removeClass('opened');
    }
    $(this).toggleClass('opened');
    if (isMobile) {
        console.log('Mobile');
        $('a.category-name').removeClass('opened');
        $(this).addClass('opened');
        if ($(this).hasClass('notActive')) {
            $(this).removeClass('opened');
        }
    }
    return false;
});

$(function () {
    $('a.category-name').addClass('notActive');
    var $set = $('.category-set');
    var len = $set.length;
    if (len && len > 1) {
        $('.category-set:first').addClass('first');
        $('.category-set:last').addClass('last');
        var divWidth = Math.floor(100 / len);
        $('.category-set').css("width", (divWidth - 1) + "%");
        if ($('.category-set').length >= 6) {
            $('.category-set').addClass('SupNumber');
        } else if ($('.category-set').length <= 3) {
            $('.category-set').addClass('InfNumber');
        } else if ($('.category-set').length >= 8) {
            $('.category-set .direct-link').addClass('SupNumber2');
        }
    }

    $("#homeMenu .menu-homepage-body .container .subCategory").each(function () {
        $("#homeMenu .menu-homepage-body .container").append($(this));
    });

    $("#subCategoryMenu .menu-homepage-body .container .subCategory").each(function () {
        $("#subCategoryMenu .menu-homepage-body .container").append($(this));
    });

});

var lastScrollTop = 0;
$(window).on('scroll', function () {
    if (!isMobile) {
        var homeMenu = $("#homeMenu").length;
        var subCategoryMenu = $("#subCategoryMenu").length;
        if (homeMenu > 0) {
            var fixedPosition = $(".master-slider").outerHeight() + $("header").outerHeight();
            var currentPosition = $(window).scrollTop();
            if (currentPosition >= fixedPosition) {
                $(".menu-homepage-body").addClass("fixedMenu");
            } else {
                $(".menu-homepage-body").removeClass("fixedMenu");
            }
        } else if (subCategoryMenu > 0) {
            var currentPosition = $(this).scrollTop();
            var start = 0;
            if (currentPosition > lastScrollTop) {
                //downscroll
                if (currentPosition >= start) {
                    $(".menu-homepage-body").addClass("fixedMenu");
                }
                else {
                    $(".menu-homepage-body").removeClass("fixedMenu");
                }

//		            	pour gérer le cas de l'ajout de la class "mini-header"
                var positionMiniHeader = 100;
                if (currentPosition <= positionMiniHeader) {
                    $('.fixedMenu').attr('style', 'top: 90px !important');
                } else {
                    $('.fixedMenu').attr('style', 'top: 60px !important');
                }
            } else {
                //upscroll
                if (currentPosition <= 3) {
                    $(".menu-homepage-body").removeClass('fixedMenu');
                }

                if (currentPosition > 3 && currentPosition <= 100) {
                    $('.fixedMenu').attr('style', 'top: 90px !important');
                }

            }
            lastScrollTop = currentPosition;

        }
    }
});

$(function () {
    if (isMobile) {
        /**
         * get homepage menu container
         * @type {*|jQuery|HTMLElement}
         */
        var menuHomePage = $('.menu-homepage-body');
        if (menuHomePage) {
            /**
             * get category set
             */
            var categorySet = menuHomePage.find('.category-set');

            /**
             * get subcategories
             */
            var subCategory = menuHomePage.find('.subCategory');

            /**
             * insert each subcategories after after their corresponding category set
             */
            for (var i = 0; i < categorySet.length; i++) {
                $(subCategory[i]).insertAfter($(categorySet[i]));
            }
        }
    }
});
/* end : BRA-5347 */

/* BRA-5115 */
$(function () {
    /**
     *
     * @type {*|jQuery|HTMLElement}
     */
    var headers = $('.faq-topics-home .item h3'),
        truncateCharactersCountLimit = 53,
        truncateCharactersCountLimitAlt = 26,
        truncateLinesCountLimit = 3;
    headers.each(function () {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var header = $(this);

        /**
         *
         */
        var headerHeight = header.height();

        /**
         *
         */
        var headerLineHeight = header.css('line-height').slice(0, header.css('line-height').length - 2);

        /**
         *
         * @type {number}
         */
        var linesCount = Math.round(headerHeight / headerLineHeight);
        if (header.text().length > truncateCharactersCountLimit) {
            /**
             *
             * @type {string}
             */
            var truncated = header.text().trim().substring(0, truncateCharactersCountLimit).split(' ').slice(0, -1).join(' ') + '…';
            header.text(truncated);
        }
        if (linesCount >= truncateLinesCountLimit) {
            /**
             *
             */
            var len = header.text().length;

            /**
             *
             */
            var truncated;

            /**
             *
             * @type {number}
             */
            var truncated_len = truncateCharactersCountLimit - 1;

            for (var i = 0; i < len; i++) {
                /**
                 *
                 */
                var headerHeight = header.height();

                /**
                 *
                 */
                var headerLineHeight = header.css('line-height').slice(0, header.css('line-height').length - 2);

                /**
                 *
                 * @type {number}
                 */
                var linesCount = Math.round(headerHeight / headerLineHeight);
                if (linesCount >= truncateLinesCountLimit) {
                    truncated = header.text().trim().substring(0, truncated_len).split(' ').slice(0, -1).join(' ') + '…';
                }
                else {
                    header.text(truncated);
                    return;
                }
                header.text(truncated);
            }
        }
    });
});
/* BRA-5115 */

$(function () {
    if (isMobile) {
        /**
         * get level 3 items count
         * @type {*|jQuery}
         */
        var nivs = document.querySelectorAll(".niv2");
      var cat = 0;
      for (index = 0; index < nivs.length; index++) {
        var level3_items_count = nivs[index].getAttribute('data-niv3-items-count');
        for (i = 0; i < parseInt(level3_items_count, 10); i++) {
          cat = index;
          for (c = index; c > 0; c--) {
            if (parseInt(nivs[c - 1].getAttribute('data-niv3-items-count'), 10) <= i) {
              cat--;
            }
          }
          processLevel3Items(i, cat, index);
        }

      }


        /**
         * remove href attribute and copy value in data-href attribute, register to click event to slide up/down content
         * @param index
         */
        function processLevel3Items(subCategoryindex, categoryIndex, superCategoryIndex) {
          var header = $('.level-3-' + subCategoryindex);
          var content = $('.level-3-' + subCategoryindex + '-items');
          var nivs = document.querySelectorAll(".niv2");
          var countLevel3 = nivs[superCategoryIndex].querySelector('.level-3-' + subCategoryindex + '-items .niv3-items-list li');
          if (countLevel3 != null) {
            header.eq(categoryIndex).find('a').attr('data-href', header.eq(categoryIndex).find('a').attr('href'));
            header.eq(categoryIndex).find('a').attr('href', '#');
            content.eq(categoryIndex).slideUp('slow');
            header.eq(categoryIndex).find('a').on('click', function (e) {
              e.stopPropagation();
              header.eq(categoryIndex).toggleClass('active');
              content.eq(categoryIndex).slideToggle('slow');
            })
          } else {
            $('.level-3-' + subCategoryindex + '-items').remove();
            $('.level-3-' + subCategoryindex + ' > a').removeClass('with-pic');
            $('.level-3-' + subCategoryindex + ' > a').addClass('without-pic');
          }
        }
    }
});


$(function () {
    if ($('.menu-homepage-body')) {
        $(".category-set a.category-name").on('hover', function () {
            // hover in
            $(".category-set a.category-name").addClass('notSelected');
            $(this).removeClass('notSelected');
            $(this).addClass('forceToRed');

        }, function () {
            // hover out
            $(".category-set a.category-name").removeClass('notSelected');
            $(this).removeClass('forceToRed');
        });
    }
});

$(function () {
    if ($('.our-applications')) {
        $('.our-applications .our-applications-banner').prependTo('.our-applications');
        if (!isMobile && !isTablet) {
            // return true if an HTML elemnt is empty
            function isEmpty(el) {
                return !$.trim(el.html())
            }

            $('.our-applications-listing-item').each(function () {
                var item = $(this);
                var logo = item.find('.our-applications-listing-logo');
                var content = item.find('.our-applications-listing-content');
                // check logo
                if (isEmpty(logo)) {
                    // decrease logo width from 15% to 0
                    $(logo).css({'width': '0'});
                    // increase content width from 60% to 75%
                    $(content).css({'width': '75%', 'padding-left': '30px'});
                }
            });
        }
    }
})

$(window).on("load", function () {
    if ($('.our-applications') && !isTablet && !isMobile) {
        var topValue = $('.our-applications-introduction').height() + $('.our-applications-description').height() + $('.our-applications-introduction-content').height() + 100;
        var viewportWidth = $('body').width();
        var containerWidth = $('.container').width();
        var leftValue = (viewportWidth - containerWidth) / 2;
        $('.our-applications-advantages-gradient').css({
            'top': topValue,
            'width': viewportWidth,
            'left': -leftValue,
            'opacity': 1
        });
    }
});


//BRA-8171
//Reload content in modal
$("a[data-target=\\#ModalMessage]").on('click', function (e) {
  e.preventDefault();
  var target = $(this).attr("href");
  if ($(this).attr("href") != null && $(this).attr("href") != "#") {
    $.ajax({
      type: "get",
      url: $(this).attr("href")
    })
      .done(function (data) {
        $("#ModalMessage .modal-body").html(data);
        $("#ModalMessage").modal('show');

      })
      .fail(function () {
        $("#ModalMessage .modal-body").html("Error Retrieving content from : " + $(this).attr("href"));
        $("#ModalMessage").modal('show');
      });
  } else {
    $("#ModalMessage").modal('show');
  }
  $("#ModalMessage .modal-body").on('load', target, function () {
    $("#ModalMessage").modal("show");
  });
});



$("#ModalMessage").on('hidden.bs.modal', function () {
  $("#ModalMessage .modal-body").empty();
});

$(function () {
    var element = $(".section-1.cookboardV2 .richcmsparagraphborder");
    if ($(element).length > 0) {
        var subDiv = $(element).find("div.richtext");
        if ($(subDiv).length > 0) {
            $(subDiv).removeClass("richtext");
        }
        $(element).addClass("richtext");
    }
});


$(function () {
	$('.trashs').each(function(){
		  if($(this).children().length == 0){
		    $(this).addClass('contains-space');
		  }else{
			$(this).removeClass('contains-space');
		  }
		});

    });

$(function () {
    var recipeItem = $(".section-5.cookboardV2 .left-mosaic .recipe-item");
    if ($(recipeItem).length == 1) {
        $(recipeItem).addClass("one-recipe");
    }
});

$('.cookboardV2 .scrollBottom span').on('click', function () {
//	recipe-product-made
    var scrollTopp = $(".recipe-product-made").offset().top - $("header").outerHeight() + 50;
    $('html,body').animate({
        scrollTop: scrollTopp
    }, 900);
});
$(function () {
    if ($('[id*="ModalMedia"]').length >= 1) {
        //console.log('At least one #ModalMedia present');
        $('[id*="ModalMedia"]').each(function () {
            var that = $(this);
            that.on('shown', function () {
                setTimeout(function () {
                    if (that.find('iframe').length === 1 && that.find('img').length <= 0) {
                        if ($('.transparent-modal-close').length <= 1) {
                            that.find('button.close').appendTo('.center-modal-iframe').wrap('<div class="transparent-modal-close"></div>');
                        }
                    } else {
                        that.removeClass('transparent-modal');
                    }
                }, 500);
            })
        });
    } else {
        //console.log('#ModalMedia NOT present');
    }
})

$(function (){
  function getElement(selector) {
    return document.querySelector(selector);
  }

  function getElements(selector) {
    return Array.from(document.querySelectorAll(selector));
  }

  const getbundlePage = function() {
    const url = $(this).attr('data-href');
    const bundleID = $(this).attr('data-bundleId');
    if ($(this).prop('checked')) {
      window.location = url + '?bundle=' + bundleID;
    }
  };

  const go2Bundle = function() {
    const url = $(this).attr('data-href');
    window.location = url + '?bundle=' + $('.js-bundle-input:checked').attr('data-bundleId');
  };


  var $DOM = {
    body : getElement('body'),
    list : getElement('.js-bundle-item'),
    overlay : getElement('.js-overlay'),
    layout : getElement('.js-bundle-item__layer'),
    layoutList : getElement('.js-bundle-list__layer'),
    wrapper : null,
    close_button : null,
    packs: getElements('.js-list__more'),
    packItems : getElements('.js-item__more'),
    radioButtons : getElements('.js-bundle-input')
  };

  $DOM.packItems && $DOM.packItems.forEach(function (trigger) {
    trigger.addEventListener('click',  function (e) {
      e.preventDefault();
      $.get($(this).attr("data-href"), function(data){
        $("#productLayer").html(data);

        //Features
        $('#productLayer .features-slider').owlMoulinex();

        //Gallery Images
        var layerProductCarousel = $("#productLayer #CarouselDetailProduct");
        if (layerProductCarousel) {
          var treeSlidesRestrictions = {
            itemSelector: "li",
            desktop: 3,
            tablet: 2,
            mobile: 1
          }
          if ($("#productLayer #CarouselDetailProduct li").length > 3 && $("#productLayer #CarouselDetailProduct .carousel-inner").length === 0) {
            $("#productLayer #CarouselDetailProduct ul").owlMoulinex('treeSlidesOptions', treeSlidesRestrictions);
          } else if ($("#productLayer #CarouselDetailProduct li").length == 1 && $('.template-pages-accessory-accessoryDetailPage').length < 0) {
            $('#productLayer #CarouselDetailProduct').hide();
          } else if ($("#productLayer #CarouselDetailProduct .carousel-inner").length) {
            if (isMobile == true) {
              $('#productLayer #CarouselDetailProduct .carousel-control').remove();
              $('#productLayer #CarouselDetailProduct .carousel-inner').append('<ul class="thumbnails"></ul>');
              $('#productLayer #CarouselDetailProduct .carousel-inner li').each(function () {
                $('#productLayer #CarouselDetailProduct .carousel-inner > ul').append($(this));
              })
              $('#productLayer #CarouselDetailProduct .carousel-inner .item').remove();
              $("#productLayer #CarouselDetailProduct ul").owlMoulinex('onlyMobileOptions');
            }
          }
        }
        // slider for product details Mobile productImageVideoMobile
        $(' #productLayer .carousel-product-mobile').owlMoulinex('enablePagination');


        //Modal
        $('#ModalMedia').on('shown', function () {
          showLoader();
          setTimeout(function () {
            if (typeof startSlide === 'undefined') {

              var startS = $('#productLayer #CarouselDetailProductBig .carousel-inner .item.active').index();

              var startThumbS = 1;
            } else {

              var startS = startSlide;

              var startThumbS = startSlide + 1;
            }

            var $bigSlider = $("#productLayer #CarouselDetailProductModal .carousel-inner");

            var bigSliderOptions = {
              rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
              stageElement: "ul",
              itemElement: "li",
              loop: false,
              nav: false,
              dots: false,
              animateIn: "fadeIn",
              animateOut: "fadeOut",
              mouseDrag: false,
              touchDrag: true,
              autoHeight: true,
              startPosition: startS,
              items: 1,
              slideBy: 1
            }

            $bigSlider.addClass('owl-carousel');
            $bigSlider.owlCarousel(bigSliderOptions);

            var $smallSlider = $("#productLayer #CarouselDetailProductMiniModal .thumbnails");

            var smallSliderOptions = {
              rtl: currentLanguage.toLowerCase().startsWith("ar") ? true : false,
              loop: true,
              nav: true,
              dots: false,
              mouseDrag: false,
              touchDrag: true,
              autoWidth: true,
              responsive: {
                0: {
                  items: 1,
                  slideBy: 1
                },
                720: {
                  items: 5,
                  slideBy: 5
                },
                1023: {
                  items: 5,
                  slideBy: 5
                }
              }
            }

            $smallSlider.on("initialized.owl.carousel", function (event) {
              $("#CarouselDetailProductMiniModal .owl-item.active:nth-child(" + startThumbS + ") a").addClass('active');
            });




            $smallSlider.on("initialize.owl.carousel", function(event) {
              $smallSlider.addClass('owl-carousel');
              var currentBreakpoint = $(window).width() >= 1023 ? 1023 : $(window).width() >= 720 ? 720 : 0;

              var itemsPerPage = smallSliderOptions.responsive[currentBreakpoint].items;
              var numberOfItems = $smallSlider.find("li").length;
              var itemsNeeded = itemsPerPage - (numberOfItems % itemsPerPage);
              while (numberOfItems % itemsPerPage > 0 && itemsNeeded > 0) {
                var placeholder = $smallSlider.find("li:last-child").clone().css("visibility", "hidden");
                $smallSlider.append(placeholder);
                itemsNeeded--;
              }

            });

            $smallSlider.owlCarousel(smallSliderOptions);

            linkRealSliders($bigSlider, $smallSlider);

            function linkRealSliders(bigS, thumbS) {
              $("#productLayer #CarouselDetailProductMiniModal .thumbnails").on("click", "a", function (e) {
                e.preventDefault();

                var newIndex = $(this).attr("data-slide-to");
                bigS.trigger("to.owl.carousel", [newIndex]);
                $("#productLayer #CarouselDetailProductMiniModal .active").removeClass('active');
                $(this).addClass('active');
              });
            }

            $("#productLayer #CarouselDetailProductMiniModal .owl-item.active:nth-child(" + startThumbS + ") a").addClass('active');
            $('#ModalMedia .modal-body').css({
              'max-height': '100%'
            });

            hideLoader();

            //initialise the thumbnail carousel to the right position
            $smallSlider.trigger("to.owl.carousel", $('#productLayer #CarouselDetailProductBig .carousel-inner .item.active').index());


          }, 300);
        });

        // minishow
        if ($('#productLayer .minishow')) {
          var treeSlidesRestrictions = {
            itemSelector: "li",
            desktop: 3,
            tablet: 2,
            mobile: 1
          }
          $('#productLayer .minishow ul').each(function () {
            if ($(this).parent().attr('ID') != 'CarouselDetailProduct' && $("#productLayer #CarouselDetailProduct .carousel-inner").length === 0) {
              $(this).owlMoulinex('treeSlidesOptions', treeSlidesRestrictions);
            }
          });
        }

        var productMedia = $('#productLayer .product-media');
        productMedia.on("click", function (e) {
          e.preventDefault();
          $.ajax({
            type: "get",
            url: $(this).data("href")
          })
            .done(Modal.displayModal)
            .fail(function () {
              console.error("Error Retrieving content from" + $(this).data("href"));
            });
        })

        $('#productLayerModal').modal();
      })
    });
  });

  $DOM.packs && $DOM.packs.forEach(function (trigger) {
    trigger.addEventListener('click',  function (e) {
      e.preventDefault();
      $("#bundleModal").modal();
    });
  });


  // events
  $('.selectBundle').on('click', getbundlePage);
  $('.go2Bundle').on('click', go2Bundle);

  $DOM.radioButtons && $DOM.radioButtons.forEach(function (trigger) {
    trigger.addEventListener('click',  function (e) {

        const selected = getElement('.bundle-selected');
        selected && selected.classList.remove('bundle-selected');

        const bundleWrapper = this.parentElement.parentElement.offsetParent.parentElement;
        bundleWrapper.classList.add('bundle-selected');

        window.location = $('.js-bundle-list__layer .selectedBundle:checked').data('href') + '?bundle=' + $('.js-bundle-list__layer .selectedBundle:checked').data('bundleid');

    });
  });

});


/**
 * [END] detail Reparability see more
 */

// Stop modal video
$('.modal').on('hidden.bs.modal', function () {
    $('iframe').each(function () {
        this.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*')
    });
})

//Cook-and-grain
$(function () {
    $('.cook-and-grain-zone2-filter-banner').on('click', function (e) {
        e.preventDefault();
        $('#cook-and-grain-more-recipes').trigger('submit');
    });
    $('.cook-and-grain-zone2-filter-banner').on('click', function (e) {
        e.preventDefault();
        $('#cook-and-grain-less-recipes').trigger('submit');
    });
    if ($('.cook-and-grain-zone2-filter-banner').length >= 1) {
        if ($('.cook-and-grain-zone2-filter-banner h5').length <= 0) {
            $('.cook-and-grain-zone2-filter-banner h4').addClass('no-subtitle');
        }
    }

    if (isMobile) {
        $(".cook-and-grain-filters .filters .item .accordion > .hideOnMobile").remove();

        $(".cook-and-grain-filters .filters .lp-recipe-filter-header").addClass("active");
        $(".cook-and-grain-filters .filters .accordion-header").addClass("in");

    } else {
        $(".cook-and-grain-filters .filters .item .accordion > .hideOnDesktop").remove();
    }

});

/*
 * [BRA-12354] - CSS - vente de prestation standard de réparation
 */
function smoothScrollingTo(target, topOffset) {
  var $target = $(target);
  if ($(".add-service-popup").length > 0) {
    var $modalBody = $(".service-popup .modal-body");
    $modalBody.animate({
      scrollTop: $target.offset().top - $modalBody.offset().top + $modalBody.scrollTop()
    }, 500);
  } else {
    if ($target.offset()) {
      $('html,body').animate({scrollTop: ($target.offset().top) - (topOffset || 80)}, 500);
    }
  }
}

function emptyCoordinatesIfNoLocationQuery(url){
    if(!(new URL(url).searchParams.get("q"))) {
        $("#nearMeStorefinderForm #latitude").val('');
        $("#nearMeStorefinderForm #longitude").val('');
    }
}

function appendStoreLocatorAjaxResultToHTML(result){
    $('[id="repair-store-filter"]').html($(result).find("#repair-store-filter").html());
    $("#search-filter_repairs").replaceWith($(result).find("#search-filter_repairs").first());
    if($(".page-my-repairers").length) {
        $(".scroll-store").html($(result).find(".scroll-store").html());
    }
    $("#StoreLocator").html($(result).find("#StoreLocator").html());
}

function pushStoreLocatorParamsToHistoryState(url) {
    var parser = document.createElement('a');
    parser.href = url;
    history.pushState({}, 'storeLocatorQueryParams', parser.search);
}

function Observable() {
  return $.extend(this, $.Deferred(), {
    next: function (value) {
      if (this.skip || this.skipAll) {
        this.skip = (value === 'skip')
        this.skipAll = this.skipAll && (value !== 'activate')
        return this
      }
      if (value === 'skip' || value === 'skipAll') {
        this[value === 'skip' || value === 'skipAll' ? value : 'isActive'] = true
        return this
      }
      return this.notify(value)
    },
    subscribe: function (callback) {
      return this.progress(function (value) {
        callback.call(this, value)
      })
    }
  })
}

function submitStoreLocatorFormWithAjax(form, method) {

    $("#StoreLocator").addClass("ajax-overlay");
    var addServiceUrl="/consumer-services/warranty-and-repairs/repairers-popup";
    var addServicePopup=$("input[name='isAddServicePopup']").val();
    var isAddServicePopup=typeof addServicePopup !== 'undefined'?addServicePopup:false;
    var submitUrl=isAddServicePopup?addServiceUrl:[location.protocol, '//', location.host, location.pathname].join('');
    $.ajax({
        type: method,
        url: submitUrl,
        data: form.serialize()
    }).done(function (result, textStatus, jqXHR) {

        var $StoreLocator = $("#StoreLocator").removeClass("ajax-overlay");

        pushStoreLocatorParamsToHistoryState(isAddServicePopup ? this.url.substring(0, this.url.indexOf('?')) : this.url);

        appendStoreLocatorAjaxResultToHTML(result);

        initScrollingStoreList();
        if (isAddServicePopup) {
            $("#accessory-pointOfServiceName").val("");
        }

      setTimeout(function () {
        if($('#nearMeStorefinderForm').parents('#ModalMessage').length) {
          GSEB.functions.scrollinModal('#ModalMessage .modal-body', isMobile ? '#map-canvas' : '#nearMeStorefinderForm');
        }else{
          GSEB.functions.scrollTo(isMobile ? '#map-canvas' : '#nearMeStorefinderForm', $("header").height() + 10);
        }
      },500);
    }).fail(function (error) {

        $("#StoreLocator").removeClass("ajax-overlay");

        console.log(error);

    });
}

function getStoreLocatorFragment(link) {

  $.ajax({
    type: 'GET',
    url: link,
  }).done(function (result, textStatus, jqXHR) {

      pushStoreLocatorParamsToHistoryState(this.url);

      appendStoreLocatorAjaxResultToHTML(result);

      initScrollingStoreList();

      if (isMobile) {
          $observables.storeLocatorObservables.next('storeLocatorRendering')
      }
  }).fail(function (error) {
      console.log(error);
  });
}

$(document).on('click', 'a.pos-feature-link[href^=\\#]', function(event){
    event.preventDefault();
    smoothScrollingTo(this.hash.replace("#","#pos-"));
    var pos_details_block_id = this.hash.replace("#","");
    $("[id^=ShopDetail-]").removeClass("pos-info-block-glow");
    $("[id^=ShopDetail-"+pos_details_block_id+"]").addClass("pos-info-block-glow activate").delay(1000).queue(function(){
        $(this).removeClass("activate").dequeue();
    });
});

window.addEventListener('popstate', function (event) {

    if($("#StoreLocator").length && !window.location.hash) {
        var url = [location.protocol, '//', location.host, location.pathname, location.search].join('');

        $("#StoreLocator").addClass("ajax-overlay");

        $.ajax({
            type: 'GET',
            url: url
        }).done(function (result, textStatus, jqXHR) {

            $("#StoreLocator").removeClass("ajax-overlay");

            emptyCoordinatesIfNoLocationQuery(url);

            appendStoreLocatorAjaxResultToHTML(result);

            initScrollingStoreList();

        }).fail(function (error) {

            $("#StoreLocator").removeClass("ajax-overlay");

            console.log(error);

        });
    }

});

/**
 * JS RCU
 */

// Login iFrame loader
(function($) {
    $.fn.bmdIframe = function( options ) {
        var settings = $.extend({
            classBtn: '.bmd-modalButton'
        }, options );

      $(document)
        .on("click", settings.classBtn, function(e) {
        	// Redirect to full page in case of IE11 or Mobile
        	if (GetIEVersion() > 0 && GetIEVersion() <= 11 || isMobile) {
        		var linkRedirect = $(this).attr('data-bmdSrc');
        		window.location.href = linkRedirect;

        	}

        var allowFullscreen = $('.bmd-modalButton').attr('data-bmdVideoFullscreen') || false;

        var attrs = {
            'src': $('.bmd-modalButton').attr('data-bmdSrc')
            };

        if ( allowFullscreen ) attrs.allowfullscreen = "";

        $('.bmd-modalContent [name="login-iframe-item"]').attr(attrs);
        $('.bmd-modalContent [name="login-iframe-item"]').iFrameResize({autoResize : true});

        if(!$(this)[0].hasAttribute("data-toggle") && $(this)[0].hasAttribute("data-bmdsrc")) {
          jQuery("#rcuLoginModal").modal();
        }


        });

        this.on('hidden.bs.modal', function(){
            $(this).find('iframe').html("").attr("src", "");
        });

        return this;
    };

})(jQuery);


jQuery(document).ready(function(){
    jQuery("#rcuLoginModal").bmdIframe();
    $('.bmd-modalContent [name="login-iframe-item"]').css('min-height','500px');
    $('[name="iframe-item"]').iFrameResize({autoResize : true, heightCalculationMethod : 'lowestElement'});
    $('[name="iframe-item"]').css('margin-bottom','50px');
    /*Remove modal target to disable login popup in IE*/
    if (GetIEVersion() > 0 && GetIEVersion() <= 11 || isMobile) {
        $("[data-target=\\#rcuLoginModal]").prop("data-target",false);
    }
    /* BRA-21111 - 547771 [SDM - RCU] Problème de time out web */
    var isAutoLoadRCUPopup = $('.bmd-modalButton-auto');
    if(isAutoLoadRCUPopup){
        $('.bmd-modalButton-auto').trigger('click');
    }
});

//Handle Intelligent Tracking Prevention issue for Safari
(function($) {

	if(isRcuActivated){
		var ua = navigator.userAgent.toLowerCase();
		if (ua.indexOf('safari') != -1 ) {
		  if (ua.indexOf('chrome') > -1) {
		    console.log("Hello from Chrome"); // Chrome
		  } else {
			  if ($.cookie("rcuFirstVisit") != "true") {
				  $.cookie("rcuFirstVisit", "true");
				  window.location.replace(sfRedirectTLPUrl);
			  }
		  	}
		}
	}
})(jQuery);

//IP-536 : Logout after anonymisation
(function($) {
	    // Listen to messages sent from the content iframe
	    var receiveMessage = function receiveMessage(e){
	        var currentUrl = window.location.href,
	            url_parts = currentUrl.split("/"),
	            baseUrl = url_parts[0] + "//" + url_parts[2];

	        // Handle the message
	        switch (e.data) {
            case 'salesforce_accountDeleted':
            {
                //Screen goes back to the deletion confirmation message.
                var $iFrameResizer0 = $('#iFrameResizer0');

                if ($iFrameResizer0.length){
                  $("html, body").animate({
                    scrollTop: $($iFrameResizer0).offset().top - 150
                  }, 500);
                }
                var delay = 5000;
                if (typeof rcuAccountDeletionDelay !== 'undefined') {
                    delay = rcuAccountDeletionDelay;
                }
                window.setTimeout(function () {
	            	window.location.replace( baseUrl + "/logout");
                }, delay);

	            	 break;
	            }
	        }
	    };
	    window.addEventListener("message", receiveMessage, false)
})(jQuery);

//IP-799 : Logout after updating password
(function($) {

    // Listen to messages sent from the content iframe
    var receiveMessage = function receiveMessage(e){
        var currentUrl = window.location.href,
            url_parts = currentUrl.split("/"),
            baseUrl = url_parts[0] + "//" + url_parts[2];

        if (currentUrl.indexOf("my-account") >= 0){
	        // Handle the message
	        switch (e.data) {
	            case 'salesforce_login': {
	            	console.log("Logout the current user");
	            	window.location.replace( baseUrl + "/logout");
	            	 break;
	            }
	        }
        }
    };

    window.addEventListener("message", receiveMessage, false);

})(jQuery);

//IP-842 scroll handling
(function($) {
        var receiveMessage = function receiveMessage(e){
            // Handle the message
            switch (e.data) {
                case 'salesforce_actionbutton': case 'salesforce_newpageload': {
                    if($('#rcuLoginModal').hasClass('in')) {
                    $('#rcuLoginModal').animate({scrollTop: 0}, 250);
                    } else {
                    $("html, body").animate({scrollTop: 0}, 250);
                    }
                    break;
                }
            }
        };
        window.addEventListener("message", receiveMessage, false)
})(jQuery);

//Get IE Version
function GetIEVersion() {
	  var sAgent = window.navigator.userAgent;
	  var Idx = sAgent.indexOf("MSIE");

	  // If IE, return version number.
	  if (Idx > 0)
	    return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));

	  // If IE 11 then look for Updated user agent string.
	  else if (!!navigator.userAgent.match(/Trident\/7\./))
	    return 11;

	  else
		  return 0; //It is not IE
}

$(".extern-cookies-popup").on('click', function(e) {
    e.preventDefault();
    tC.privacyCenter.showPrivacyCenter();
});

/**
 * JS RCU
 */


/**
 * Close cartError modal {{ [data-dismiss="modal"] doesn't work properly !!! }}
 * Then continue the request,
 * Used in Moulinex's addToCartPopup
 */
function closeModalAndContinue() {
  $('#ModalCartError').modal('hide');
}


$(document).on("click",".add_service_form .add-to-cart", function(e) {
	e.preventDefault();
    $.ajax({
        url:"/cart/add/service/ajax",
        data:$(this).closest("form").serialize(),
        async: false
    }).done(function (data) {
        var selectModal = "#ModalMessage";
        if (data.cartError && !data.cartError.msg.length == 0) {
            modalId = "ModalCartError";
            $('body').append($('<div />').html(data.cartError.msgModalHtml).text());
            selectModal = '#' + modalId;
            $(selectModal).on('hidden.bs.modal', function () {
                $(selectModal).remove();
            });
        } else {
            $(selectModal).html(data);
            $(selectModal).addClass('service-popup');
            var closeButton = '<button type="button" class="close close--red" data-dismiss="modal" aria-hidden="true"> <img src="/_ui/desktop/common/img/close-big.png" alt="alt"> </button>';
            $("#ModalMessage").find('#relayPointsContainer').prepend(closeButton);
            /*BRA-19430 */
            $("#ModalMessage").find('#repair-store-filter').on('hidden.bs.collapse', function (e) {
                if (!e)
                    e = window.event;
                if (e.stopPropagation) {
                    e.stopPropagation();
                }
                else {
                    e.cancelBubble = true;
                }
            });
            $("#ModalMessage").find('.d-none-md #repair-store-filter').on('hidden.bs.collapse', function (e) {
                if (!e)
                    e = window.event;
                if (e.stopPropagation) {
                    e.stopPropagation();
                }
                else {
                    e.cancelBubble = true;
                }
            });
            $("#ModalMessage").on('hidden.bs.modal', function () {
                $("#ModalMessage .modal-body").html("");
            });
            var isForfaitShippingIncluded = $(data).find("[data-forfaitShippingIncluded]").length > 0;
            if(!isForfaitShippingIncluded) {
                $observables.storeLocatorObservables.next('skip');
                ACC.addressgeocode.geocodeAddress();
            }
        }
        $(selectModal).show();
        $(selectModal).modal();
    }).fail(function (error) {
        console.error(error);
        var modal = $("#ModalMessage");
        var modalBody = modal.find(".modal-body");
        var sb = new StringBuilder();
        sb.append("<p style='margin-bottom: 20px;'>" + GSEB.properties.defaultCartErrorMessage + "</p>");
        sb.append("<button class='btn btn-action' data-dismiss='modal' style='margin:0 auto; display: block; width: auto; text-align: center'>"+ closePopup +"</button>");
        modalBody.html(sb.toString());
        modal.show();
        modal.modal();
    });
});

 function chooseAspForReparation(currentAsp,aspName){
	 $("input[id='accessory-pointOfServiceName']").val(aspName);
	 $(".asp-choosed").removeClass("asp-choosed");
	 $("#ShopDetail-"+aspName).find(".inner").addClass("asp-choosed");
	 $("#add-service-messageError").hide();
 }


function closeModalMessage(idModalMessage) {
    $('#' + idModalMessage).modal('hide');
    $(".add-service-popup").remove();
}


// BRA-17342 price claim overlaping
$('.accessoires .caption.main-claim .claim').each(function(){
    $clamp(this, {clamp: 3});
});

//RCU Newsletter
$('#register-rules[type="checkbox"][name="conditionRegister"]').prop("checked", false).trigger('change');
$('#register-rules, .newsletter-label').on('change', function (e) {
    $('#register-rules').toggleClass('checked');
});

$('.infobulle-gauche').on('click', function (e) {
  $('.infobulle-gauche').toggleClass('isOpen');
});

$(document).ready(function(){
	$("body").on('mouseup', function(e)
	{
		var container = $('.infobulle-gauche');
		if (!container.is(e.target) && container.has(e.target).length === 0) {
	        container.removeClass('isOpen');
	    }
	});
});
$(document).ready(function(){
    window.$observables = window.$observables || {};
    $observables.prcListObservable = $observables.prcListObservable || new Observable();
    if(isMobile) {
        if($observables){
            $observables.mainObservable.subscribe(function(event) {
                if(event.type === 'prc-scroll-to-maps'){

                    $('#relayPointsContainer').animate({
                        scrollTop: $("#map-canvas").offset().top + 100
                    });
                }

            });
            $observables.prcListObservable.subscribe(function (event) {
                if (event.type === 'prc-list-scroll-to-item') {
                    $container = $('#relayPointsContainer');
                    $scrollToElement = $('#pointAcheminementDetail-'+event.identifiant);
                    $container.animate({
                        scrollTop: $scrollToElement.offset().top - $('.relaitList').offset().top + 570
                    });
                }
            });
        }
    }
    $(document).on('hidden.bs.collapse','#search-list-page--filters-container .accordion-group', function(e){
        e.stopPropagation();
    });
    $(document).on("click",".claim-container:not(.main-claim a)",function(e) {
        if(!$(e.target).is('a')){
            document.location.href =$('.claim-container').data('product-url');
        }
    });
    $('.claim-container').on("click",".main-claim a",function(e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    });

});

/**
 *  Live-chat
 */

document.addEventListener("DOMContentLoaded", function () {

  if (showChat == "true") {
    if (!GSEB.platform.isMobile()) {
      setTimeout(function () {
        $('.live-chat-block').addClass("live-chat-block-semi-active").removeClass("live-chat-block-inactive");
        setTimeout(function () {
          $('.live-chat-block').addClass("live-chat-block-inactive").removeClass("live-chat-block-semi-active");
        }, liveChatDuration);
      }, liveChatDelay);
    }
    $(".live-chat-block").on("click",".live-chat-picto",function(){
      $('.live-chat-block').addClass("live-chat-block-active").removeClass("live-chat-block-inactive")
        .removeClass("live-chat-block-semi-active");
      $('.live-chat-block').attr("data-analytics-chatClick-chatAction","Open");
      $('.live-chat-block .live-chat-picto').hide(750);
      $('.live-chat-block .live-chat-close').show(750);
    });

    $(".live-chat-block").on("click",".helpButton",function(){
      $('.live-chat-block').attr("data-analytics-chatClick-chatAction", "Ask a question");
    });

    $('.live-chat-block .live-chat-close').click(function (e) {
      $('.live-chat-block').removeClass("live-chat-block-active").addClass("live-chat-block-inactive");
      $('.live-chat-block').attr("data-analytics-chatClick-chatAction","Close");
      $('.live-chat-block .live-chat-picto').show(750);
      $('.live-chat-block .live-chat-close').hide(750);
    });
  }

  $(".more-products").click(function () {
    $('.remaining-products-link').hide();
    $('.list-remaining-products').show();
  });

});

/**
 * Moulinex DTC
 */
$(document).ready(function () {
  //RTDTC-224
  $('.deliveryInformation').on('click',function (event) {
    event.preventDefault();
    $('#productDeliveryInformationModal').modal();
  });
  $(window).on('scroll', function() {
    const stickyCart = $('.sticky-cart');
    var headerOffset = $('.wrap-header').offset().top;

    if (headerOffset > 0) {
      stickyCart.slideDown(200);

    } else {
      //Todo specify exactly when to display the sticky-cart box
      stickyCart.slideUp(200);
    }
  });
  if($('#master-detail-product').hasClass('onSaleProduct')){
    $('body').addClass('onSaleProduct')
  }
  $(window).on('scroll', function() {
    if ($('body').hasClass('page-productDetails') && $(document).width() <= 1024) {
      const liveChatBlock = $('.live-chat-block-inactive');
      var headerOffset = $('.wrap-header').offset().top;

      if (headerOffset > 0) {
        liveChatBlock.addClass("bottom-80");
      } else {
        liveChatBlock.removeClass("bottom-80");
      }
    }
  });
});


$('.js-alert-stock').on('click', function (event) {
  event.preventDefault();
  const productCode = this.dataset.productCode;
  const popinUrl = '/popin/stockAlertForm/p/' + productCode;
  $.ajax({
    url: popinUrl,
    type: 'GET'
  }).done(function (data) {
    const modal = $('#ModalMessage');
    const modalBody = modal.find('.modal-body');
    modalBody.html(data);
    modal.modal();
  });
});

// =============== disable/enable addToCartForm submit button, to ensure that the modal is loaded ==============
$('.dtc form[name="addToCartForm"] a, .dtc form[name="addToCartForm"] button[type="submit"]')
  .prop('disabled', true);

$(document).ready(function() {
  $('.dtc form[name="addToCartForm"] a, .dtc form[name="addToCartForm"] button[type="submit"]')
    .prop('disabled', false);
});
// =============== disable/enable addToCartForm submit button, to ensure that the modal is loaded ==============

//=============== Bind comparator functions to #plp-results-section =================
$("#plp-results-section").on('click', "[data-analytics-addToComparator]", function () {
  if($('.c-sticky-comparator-desktop').length > 0 || $('.c-sticky-comparator-mobile').length > 0) {
    if ($(this).is(':checked')) {
      addProductCompare($(this));
    } else {
      deleteProductFromCompare($(this));
    }
  }
});
//=============== Bind comparator functions to #plp-results-section =================


//scroll poppin to top
var element = document.querySelector('#ModalMessage');
var observer = new MutationObserver(function() {
  document.querySelector("#ModalMessage .modal-body").scrollTo(0,0)
});
observer.observe(element, {
  attributes: true, childList: false
});
